/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: adminAddProductImages
// ====================================================

export interface adminAddProductImages_adminAddProductImages_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface adminAddProductImages_adminAddProductImages {
  __typename: "ProductImage";
  id: string;
  url: string;
  mime_type: string;
  size: number;
  is_default: boolean;
  conversions: adminAddProductImages_adminAddProductImages_conversions;
}

export interface adminAddProductImages {
  adminAddProductImages: adminAddProductImages_adminAddProductImages[] | null;
}

export interface adminAddProductImagesVariables {
  product_id: string;
  images: AdminProductImageInput[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: adminDeleteProductImages
// ====================================================

export interface adminDeleteProductImages_adminDeleteProductImages_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface adminDeleteProductImages_adminDeleteProductImages {
  __typename: "ProductImage";
  id: string;
  url: string;
  mime_type: string;
  size: number;
  is_default: boolean;
  conversions: adminDeleteProductImages_adminDeleteProductImages_conversions;
}

export interface adminDeleteProductImages {
  adminDeleteProductImages: adminDeleteProductImages_adminDeleteProductImages[] | null;
}

export interface adminDeleteProductImagesVariables {
  product_id: string;
  image_ids: string[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: adminLogin
// ====================================================

export interface adminLogin_adminLogin_user {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

export interface adminLogin_adminLogin {
  __typename: "AuthenticationResult";
  token: string | null;
  user: adminLogin_adminLogin_user | null;
}

export interface adminLogin {
  adminLogin: adminLogin_adminLogin;
}

export interface adminLoginVariables {
  email: string;
  password: string;
  type: AuthenticationType;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: adminModifyOrder
// ====================================================

export interface adminModifyOrder_adminModifyOrder_user_orders_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface adminModifyOrder_adminModifyOrder_user_orders {
  __typename: "OrderPaginator";
  paginatorInfo: adminModifyOrder_adminModifyOrder_user_orders_paginatorInfo;
}

export interface adminModifyOrder_adminModifyOrder_user {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  ext_id: string;
  orders: adminModifyOrder_adminModifyOrder_user_orders | null;
}

export interface adminModifyOrder_adminModifyOrder_contact_data {
  __typename: "ContactPersonData";
  contact_name: string;
  contact_email: string;
  contact_telephone: string;
}

export interface adminModifyOrder_adminModifyOrder_status {
  __typename: "OrderStatus";
  title: string;
  code: OrderStatusCode;
}

export interface adminModifyOrder_adminModifyOrder_shipping_method {
  __typename: "ShippingMethod";
  id: string;
  name: string;
}

export interface adminModifyOrder_adminModifyOrder {
  __typename: "Order";
  id: string;
  created_at: any;
  user: adminModifyOrder_adminModifyOrder_user | null;
  contact_data: adminModifyOrder_adminModifyOrder_contact_data | null;
  total_amount: number;
  total_sum: number;
  status: adminModifyOrder_adminModifyOrder_status;
  shipping_method: adminModifyOrder_adminModifyOrder_shipping_method;
  is_admin_checked: boolean | null;
  /**
   *  A kapcsolt rendelés (parent_order) id-ja 
   */
  linked_order_id: string | null;
}

export interface adminModifyOrder {
  adminModifyOrder: adminModifyOrder_adminModifyOrder;
}

export interface adminModifyOrderVariables {
  id: string;
  is_admin_checked?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: adminSortProductImages
// ====================================================

export interface adminSortProductImages_adminSortProductImages_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface adminSortProductImages_adminSortProductImages {
  __typename: "ProductImage";
  id: string;
  url: string;
  mime_type: string;
  size: number;
  is_default: boolean;
  conversions: adminSortProductImages_adminSortProductImages_conversions;
}

export interface adminSortProductImages {
  adminSortProductImages: adminSortProductImages_adminSortProductImages[] | null;
}

export interface adminSortProductImagesVariables {
  product_id: string;
  image_ids: string[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: adminUpdateProduct
// ====================================================

export interface adminUpdateProduct_adminUpdateProduct_categories {
  __typename: "ProductCategory";
  id: string;
  name: string;
}

export interface adminUpdateProduct_adminUpdateProduct_vote_calculated {
  __typename: "ProductVoteCalculated";
  /**
   * A termékre leadott szavazatok átlaga
   */
  vote_avg: number;
  vote_count_one: number;
  vote_count_two: number;
  vote_count_three: number;
  vote_count_four: number;
  vote_count_five: number;
}

export interface adminUpdateProduct_adminUpdateProduct_empties {
  __typename: "Product";
  id: string;
  name: string;
}

export interface adminUpdateProduct_adminUpdateProduct_attributes_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
}

export interface adminUpdateProduct_adminUpdateProduct_attributes {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  options: adminUpdateProduct_adminUpdateProduct_attributes_options[] | null;
}

export interface adminUpdateProduct_adminUpdateProduct_images_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface adminUpdateProduct_adminUpdateProduct_images {
  __typename: "ProductImage";
  id: string;
  url: string;
  conversions: adminUpdateProduct_adminUpdateProduct_images_conversions;
}

export interface adminUpdateProduct_adminUpdateProduct {
  __typename: "AdminProduct";
  id: string;
  /**
   *  ERP-ben használt id 
   */
  ext_id: number | null;
  /**
   * Régi webshop termék id
   */
  previous_id: string | null;
  name: string;
  /**
   * Termék státusza/elérhetősége
   */
  status: ProductStatus;
  /**
   * Új url
   */
  url_key: string | null;
  /**
   * Régi url
   */
  smarturl: string | null;
  categories: adminUpdateProduct_adminUpdateProduct_categories[] | null;
  default_category_id: number | null;
  price: number;
  /**
   * Az egységár egysége
   */
  price_unit: string | null;
  /**
   * Az egységár szorzója
   */
  price_per_unit: number | null;
  /**
   * Egységár
   */
  unit_price: number | null;
  /**
   * Akciós egységár
   */
  special_unit_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes ár 
   */
  personal_discount_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes egységár 
   */
  personal_discount_unit_price: number | null;
  /**
   * ÁFA
   */
  vat: number;
  /**
   * Akciós ár, bruttó
   */
  special_price: number | null;
  /**
   * Az akciós ár ettől a dátumtól érvényes
   */
  special_from_date: any | null;
  /**
   * Az akciós ár eeddig a dátumig érvényes
   */
  special_to_date: any | null;
  /**
   * Ettől a dátumtól "új" a termék
   */
  news_from_date: any | null;
  /**
   * Eddig a dátumig "új" a termék
   */
  news_to_date: any | null;
  /**
   * Leírás
   */
  description: string | null;
  /**
   * Összetevők leírása
   */
  components: string | null;
  /**
   * Tápanyaginformációk
   */
  nutrition_data: string | null;
  /**
   * A termékre leadott szavazatok aggregálva
   */
  vote_calculated: adminUpdateProduct_adminUpdateProduct_vote_calculated | null;
  /**
   * Prefixboxtól kapott terméknépszerűség szám
   */
  prefixbox_score: number | null;
  /**
   * Vonalkódok
   */
  barcodes: string[] | null;
  /**
   * Alternatív mennyiség neve
   */
  alternative_quantity_name: ProductAlternativeQuantityName | null;
  /**
   * Alternatív mennyiség legkisebb választható egsége
   */
  alternative_quantity_minimum: number | null;
  /**
   * Alternatív mennyiség léptetési egysége
   */
  alternative_quantity_scale: number | null;
  /**
   * Eredeti/alternatív egység átváltási arány
   */
  alternative_quantity_exchange_rate: number | null;
  /**
   * Alapértelmezett mennyiség neve
   */
  default_quantity_name: ProductDefaultQuantityName | null;
  /**
   * Alapértelmezett mennyiség legkisebb választható egysége
   */
  default_quantity_minimum: number | null;
  /**
   * Alapértelmezett mennyiség léptetési egysége
   */
  default_quantity_scale: number | null;
  /**
   * Nem egész mennyiség is kosárba rakható-e a termékből (alapértelmezett mennyiségre vonatkozik)
   */
  is_qty_decimal: boolean;
  /**
   * Ajándékkártyával rendelhető
   */
  gift_message_available: boolean;
  /**
   * Csomagfutárral (MPL) szállítható
   */
  is_mpl: boolean;
  meta_title: string | null;
  meta_description: string | null;
  meta_keywords: string | null;
  /**
   * Minimum szavatosság: x nap
   */
  min_expiry_days: number | null;
  /**
   * A termék tényleges tömege
   */
  package_official_g: number | null;
  /**
   * A termék tényleges űrtartalma
   */
  package_official_ml: number | null;
  /**
   * Szeletelve rendelhető
   */
  sliceable: boolean | null;
  /**
   * Tömeg grammban
   */
  weight: number;
  /**
   * Göngyöleg
   */
  empties: adminUpdateProduct_adminUpdateProduct_empties | null;
  /**
   *  A termékhez rendelt attribútumok és értékeik
   */
  attributes: adminUpdateProduct_adminUpdateProduct_attributes[] | null;
  /**
   * Termék képek
   */
  images: adminUpdateProduct_adminUpdateProduct_images[] | null;
  created_at: any;
  updated_at: any | null;
  /**
   * Internetes ár
   */
  webshop_only_price: boolean;
}

export interface adminUpdateProduct {
  adminUpdateProduct: adminUpdateProduct_adminUpdateProduct;
}

export interface adminUpdateProductVariables {
  id: string;
  status?: ProductStatus | null;
  gift_message_available?: boolean | null;
  is_mpl?: boolean | null;
  description?: string | null;
  components?: string | null;
  nutrition_data?: string | null;
  meta_title?: string | null;
  meta_description?: string | null;
  meta_keywords?: string | null;
  min_expiry_days?: number | null;
  sliceable?: boolean | null;
  weight?: number | null;
  attribute_option_ids: (string | null)[];
  category_ids: (string | null)[];
  alternative_quantity_scale?: number | null;
  alternative_quantity_minimum?: number | null;
  alternative_quantity_exchange_rate?: number | null;
  alternative_quantity_name?: ProductAlternativeQuantityName | null;
  default_quantity_minimum?: number | null;
  default_quantity_scale?: number | null;
  is_qty_decimal?: boolean | null;
  webshop_only_price?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: adminUpdateProductMainImage
// ====================================================

export interface adminUpdateProductMainImage_adminUpdateProductMainImage_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface adminUpdateProductMainImage_adminUpdateProductMainImage {
  __typename: "ProductImage";
  id: string;
  url: string;
  mime_type: string;
  size: number;
  is_default: boolean;
  conversions: adminUpdateProductMainImage_adminUpdateProductMainImage_conversions;
}

export interface adminUpdateProductMainImage {
  adminUpdateProductMainImage: adminUpdateProductMainImage_adminUpdateProductMainImage;
}

export interface adminUpdateProductMainImageVariables {
  product_id: string;
  file_name: string;
  base64_image: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: adminUpdateTimetableTimeSlot
// ====================================================

export interface adminUpdateTimetableTimeSlot_adminUpdateTimetableTimeSlot {
  __typename: "TimetableTimeSlot";
  id: string;
  status: TimetableTimeSlotStatusType;
}

export interface adminUpdateTimetableTimeSlot {
  adminUpdateTimetableTimeSlot: adminUpdateTimetableTimeSlot_adminUpdateTimetableTimeSlot;
}

export interface adminUpdateTimetableTimeSlotVariables {
  id: number;
  status: TimetableTimeSlotStatusType;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createBanner
// ====================================================

export interface createBanner_createBanner_banner_places {
  __typename: "BannerPlace";
  id: string;
  name: string;
}

export interface createBanner_createBanner {
  __typename: "AdminBanner";
  id: string;
  name: string;
  active_from: any | null;
  active_to: any | null;
  is_active: boolean;
  banner_places: createBanner_createBanner_banner_places[];
}

export interface createBanner {
  createBanner: createBanner_createBanner;
}

export interface createBannerVariables {
  name: string;
  active_from?: any | null;
  active_to?: any | null;
  url: string;
  url_target: BannerUrlTarget;
  image_url_desktop: string;
  image_url_mobile: string;
  is_active: boolean;
  priority: number;
  banner_place_ids: string[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createCmsContent
// ====================================================

export interface createCmsContent_createCmsContent {
  __typename: "AdminCmsContent";
  id: string;
  title: string;
  url_key: string;
  is_active: boolean;
  active_from: any | null;
  active_to: any | null;
}

export interface createCmsContent {
  createCmsContent: createCmsContent_createCmsContent;
}

export interface createCmsContentVariables {
  title: string;
  content?: string | null;
  is_active: boolean;
  active_from?: any | null;
  active_to?: any | null;
  url_key: string;
  meta_title?: string | null;
  meta_keywords?: string | null;
  meta_description?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createCoupon
// ====================================================

export interface createCoupon_createCoupon_codes_data {
  __typename: "CouponCode";
  /**
   *  Ennyiszer használható fel a kuponkód 
   */
  usage_count: number;
}

export interface createCoupon_createCoupon_codes {
  __typename: "CouponCodePaginator";
  data: createCoupon_createCoupon_codes_data[];
}

export interface createCoupon_createCoupon {
  __typename: "Coupon";
  id: string;
  name: string;
  active_from: any;
  active_to: any;
  type: CouponType;
  /**
   *  Mire érvényes: termék, szállítás 
   */
  applied_to: CouponAppliedTo;
  /**
   *  + ingyen szállítás? 
   */
  is_free_shipping: boolean;
  is_active: boolean;
  /**
   *  Ennyiszer haszálhatóak fel a kuponhoz tartozó kódok 
   */
  usage_count: number;
  /**
   *  Más kedvezménnyel összevonható? 
   */
  is_combinable: boolean;
  created_at: any;
  updated_at: any | null;
  /**
   *  Generált kuponkódok száma 
   */
  generated_codes_count: number;
  /**
   *  Felhasznált kuponkódok száma 
   */
  used_codes_count: number;
  codes: createCoupon_createCoupon_codes | null;
}

export interface createCoupon {
  createCoupon: createCoupon_createCoupon;
}

export interface createCouponVariables {
  name: string;
  description?: string | null;
  active_from: string;
  active_to: string;
  type: CouponType;
  applied_to: CouponAppliedTo;
  is_free_shipping: boolean;
  price_ranges: CouponPriceRangeInput[];
  is_active: boolean;
  shipping_method_id?: string | null;
  payment_method_id?: string | null;
  usage_count: number;
  is_combinable: boolean;
  coupon_code_attributes?: CouponCodeAttributes | null;
  codes?: string[] | null;
  products?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createDonation
// ====================================================

export interface createDonation_createDonation {
  __typename: "AdminDonation";
  id: string;
}

export interface createDonation {
  createDonation: createDonation_createDonation;
}

export interface createDonationVariables {
  name: string;
  cms_url: string;
  active: DonationActiveDates;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createProductAttribute
// ====================================================

export interface createProductAttribute_createProductAttribute_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
  position: number | null;
  is_active: boolean;
  is_default: boolean;
}

export interface createProductAttribute_createProductAttribute {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  /**
   *  Az attribútumra lehet-e szűrni a termékeket
   */
  filterable: boolean | null;
  is_active: boolean | null;
  /**
   *  Az attribútum típusa
   */
  type: ProductAttributeType;
  options: createProductAttribute_createProductAttribute_options[] | null;
}

export interface createProductAttribute {
  createProductAttribute: createProductAttribute_createProductAttribute;
}

export interface createProductAttributeVariables {
  name: string;
  code: string;
  filterable: boolean;
  is_active: boolean;
  type: ProductAttributeType;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createProductAttributeOption
// ====================================================

export interface createProductAttributeOption_createProductAttributeOption {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
  position: number | null;
  is_active: boolean;
  is_default: boolean;
}

export interface createProductAttributeOption {
  createProductAttributeOption: createProductAttributeOption_createProductAttributeOption | null;
}

export interface createProductAttributeOptionVariables {
  label: string;
  is_active: boolean;
  is_default?: boolean | null;
  product_attribute_id: string;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createProductCategory
// ====================================================

export interface createProductCategory_createProductCategory_children_children {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  product_count: number;
}

export interface createProductCategory_createProductCategory_children {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  children: createProductCategory_createProductCategory_children_children[] | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  is_homepage_prohibited: boolean;
  product_count: number;
}

export interface createProductCategory_createProductCategory {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  children: createProductCategory_createProductCategory_children[] | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  promotion_place: PromotionPlace | null;
  is_homepage_prohibited: boolean;
  product_count: number;
}

export interface createProductCategory {
  createProductCategory: createProductCategory_createProductCategory | null;
}

export interface createProductCategoryVariables {
  name: string;
  parent_id?: number | null;
  url_key: string;
  content?: string | null;
  is_enable: boolean;
  date_to?: string | null;
  date_from?: string | null;
  show_in_menu: boolean;
  keywords?: string | null;
  description?: string | null;
  is_promotion: boolean;
  is_homepage_prohibited: boolean;
  promotion_place?: PromotionPlace | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createProductListAd
// ====================================================

export interface createProductListAd_createProductListAd {
  __typename: "AdminProductListAd";
  id: string;
}

export interface createProductListAd {
  createProductListAd: createProductListAd_createProductListAd;
}

export interface createProductListAdVariables {
  name: string;
  banner_url?: string | null;
  type: ProductListAdType;
  product_id?: string | null;
  image_url_desktop?: string | null;
  image_url_mobile?: string | null;
  is_active: boolean;
  active_from?: string | null;
  active_to?: string | null;
  urls: ProductListAdUrlInput[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createUrlAlias
// ====================================================

export interface createUrlAlias_createUrlAlias {
  __typename: "UrlAlias";
  id: string;
  source_url: string;
  target_url: string;
  created_at: any;
  updated_at: any | null;
}

export interface createUrlAlias {
  createUrlAlias: createUrlAlias_createUrlAlias;
}

export interface createUrlAliasVariables {
  source_url: string;
  target_url: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createUserProductDiscount
// ====================================================

export interface createUserProductDiscount_createUserProductDiscount {
  __typename: "UserProductDiscount";
  id: string;
  user_id: string;
  is_active: boolean;
  active_from: any;
  active_to: any;
  created_at: any;
  updated_at: any;
}

export interface createUserProductDiscount {
  createUserProductDiscount: createUserProductDiscount_createUserProductDiscount | null;
}

export interface createUserProductDiscountVariables {
  user_id: string;
  is_active: boolean;
  discount: number;
  active_from: string;
  active_to: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createUserShippingDiscount
// ====================================================

export interface createUserShippingDiscount_createUserShippingDiscount {
  __typename: "UserShippingDiscount";
  id: string;
  user_id: string;
  is_active: boolean;
  active_from: any;
  active_to: any;
  created_at: any;
  updated_at: any;
}

export interface createUserShippingDiscount {
  createUserShippingDiscount: createUserShippingDiscount_createUserShippingDiscount | null;
}

export interface createUserShippingDiscountVariables {
  user_id: string;
  is_active: boolean;
  discount: number;
  active_from: string;
  active_to: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteProductAttribute
// ====================================================

export interface deleteProductAttribute_deleteProductAttribute_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
  position: number | null;
  is_active: boolean;
  is_default: boolean;
}

export interface deleteProductAttribute_deleteProductAttribute {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  /**
   *  Az attribútumra lehet-e szűrni a termékeket
   */
  filterable: boolean | null;
  is_active: boolean | null;
  /**
   *  Az attribútum típusa
   */
  type: ProductAttributeType;
  options: deleteProductAttribute_deleteProductAttribute_options[] | null;
}

export interface deleteProductAttribute {
  deleteProductAttribute: deleteProductAttribute_deleteProductAttribute;
}

export interface deleteProductAttributeVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteProductAttributeOption
// ====================================================

export interface deleteProductAttributeOption_deleteProductAttributeOption {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
  position: number | null;
  is_active: boolean;
  is_default: boolean;
}

export interface deleteProductAttributeOption {
  deleteProductAttributeOption: deleteProductAttributeOption_deleteProductAttributeOption;
}

export interface deleteProductAttributeOptionVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteUrlAlias
// ====================================================

export interface deleteUrlAlias_deleteUrlAlias {
  __typename: "UrlAlias";
  id: string;
  source_url: string;
  target_url: string;
  created_at: any;
  updated_at: any | null;
}

export interface deleteUrlAlias {
  deleteUrlAlias: deleteUrlAlias_deleteUrlAlias;
}

export interface deleteUrlAliasVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: enableBankTransferForBillingAddress
// ====================================================

export interface enableBankTransferForBillingAddress_enableBankTransferForBillingAddress {
  __typename: "UserBillingAddress";
  id: string;
}

export interface enableBankTransferForBillingAddress {
  enableBankTransferForBillingAddress: enableBankTransferForBillingAddress_enableBankTransferForBillingAddress;
}

export interface enableBankTransferForBillingAddressVariables {
  address_id: string;
  enable: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: grantAdminRightToUser
// ====================================================

export interface grantAdminRightToUser_grantAdminRightToUser {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

export interface grantAdminRightToUser {
  grantAdminRightToUser: grantAdminRightToUser_grantAdminRightToUser;
}

export interface grantAdminRightToUserVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: loginAsUser
// ====================================================

export interface loginAsUser_loginAsUser_user {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

export interface loginAsUser_loginAsUser {
  __typename: "AuthenticationResult";
  token: string | null;
  user: loginAsUser_loginAsUser_user | null;
}

export interface loginAsUser {
  loginAsUser: loginAsUser_loginAsUser;
}

export interface loginAsUserVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: revokeAdminRightFromUser
// ====================================================

export interface revokeAdminRightFromUser_revokeAdminRightFromUser {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

export interface revokeAdminRightFromUser {
  revokeAdminRightFromUser: revokeAdminRightFromUser_revokeAdminRightFromUser;
}

export interface revokeAdminRightFromUserVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setAdminIpAddress
// ====================================================

export interface setAdminIpAddress_setAdminIpAddress {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

export interface setAdminIpAddress {
  setAdminIpAddress: setAdminIpAddress_setAdminIpAddress;
}

export interface setAdminIpAddressVariables {
  id: string;
  ip_address?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateBanner
// ====================================================

export interface updateBanner_updateBanner_banner_places {
  __typename: "BannerPlace";
  id: string;
  name: string;
}

export interface updateBanner_updateBanner {
  __typename: "AdminBanner";
  id: string;
  name: string;
  active_from: any | null;
  active_to: any | null;
  is_active: boolean;
  banner_places: updateBanner_updateBanner_banner_places[];
}

export interface updateBanner {
  updateBanner: updateBanner_updateBanner;
}

export interface updateBannerVariables {
  id: string;
  name: string;
  active_from?: any | null;
  active_to?: any | null;
  url: string;
  url_target: BannerUrlTarget;
  image_url_desktop: string;
  image_url_mobile: string;
  is_active: boolean;
  priority: number;
  banner_place_ids: string[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateCmsContent
// ====================================================

export interface updateCmsContent_updateCmsContent {
  __typename: "AdminCmsContent";
  id: string;
  title: string;
  url_key: string;
  is_active: boolean;
  active_from: any | null;
  active_to: any | null;
}

export interface updateCmsContent {
  updateCmsContent: updateCmsContent_updateCmsContent;
}

export interface updateCmsContentVariables {
  id: string;
  title: string;
  content?: string | null;
  is_active: boolean;
  active_from?: any | null;
  active_to?: any | null;
  url_key: string;
  meta_title?: string | null;
  meta_keywords?: string | null;
  meta_description?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateCoupon
// ====================================================

export interface updateCoupon_updateCoupon_codes_data {
  __typename: "CouponCode";
  /**
   *  Ennyiszer használható fel a kuponkód 
   */
  usage_count: number;
}

export interface updateCoupon_updateCoupon_codes {
  __typename: "CouponCodePaginator";
  data: updateCoupon_updateCoupon_codes_data[];
}

export interface updateCoupon_updateCoupon {
  __typename: "Coupon";
  id: string;
  name: string;
  active_from: any;
  active_to: any;
  type: CouponType;
  /**
   *  Mire érvényes: termék, szállítás 
   */
  applied_to: CouponAppliedTo;
  /**
   *  + ingyen szállítás? 
   */
  is_free_shipping: boolean;
  is_active: boolean;
  /**
   *  Ennyiszer haszálhatóak fel a kuponhoz tartozó kódok 
   */
  usage_count: number;
  /**
   *  Más kedvezménnyel összevonható? 
   */
  is_combinable: boolean;
  created_at: any;
  updated_at: any | null;
  /**
   *  Generált kuponkódok száma 
   */
  generated_codes_count: number;
  /**
   *  Felhasznált kuponkódok száma 
   */
  used_codes_count: number;
  codes: updateCoupon_updateCoupon_codes | null;
}

export interface updateCoupon {
  updateCoupon: updateCoupon_updateCoupon;
}

export interface updateCouponVariables {
  id: string;
  name: string;
  description?: string | null;
  active_from: string;
  active_to: string;
  type: CouponType;
  applied_to: CouponAppliedTo;
  is_free_shipping: boolean;
  price_ranges: CouponPriceRangeInput[];
  is_active: boolean;
  shipping_method_id?: string | null;
  payment_method_id?: string | null;
  usage_count: number;
  is_combinable: boolean;
  coupon_code_attributes?: CouponCodeAttributes | null;
  codes?: string[] | null;
  products?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateDonation
// ====================================================

export interface updateDonation_updateDonation {
  __typename: "AdminDonation";
  id: string;
}

export interface updateDonation {
  updateDonation: updateDonation_updateDonation;
}

export interface updateDonationVariables {
  id: string;
  name?: string | null;
  cms_url?: string | null;
  active?: DonationActiveDates | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePaymentMethod
// ====================================================

export interface UpdatePaymentMethod_adminUpdatePaymentMethod {
  __typename: "PaymentMethod";
  id: string;
  name: string;
  is_active: boolean;
  sort: number;
  short_description: string | null;
  short_description_mpl_type: string | null;
  cost: number;
}

export interface UpdatePaymentMethod {
  adminUpdatePaymentMethod: UpdatePaymentMethod_adminUpdatePaymentMethod;
}

export interface UpdatePaymentMethodVariables {
  id: string;
  name?: string | null;
  is_active?: boolean | null;
  before?: number | null;
  after?: number | null;
  short_description?: string | null;
  short_description_mpl_type?: string | null;
  cost?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateProductAttribute
// ====================================================

export interface UpdateProductAttribute_updateProductAttribute_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
  position: number | null;
  is_active: boolean;
  is_default: boolean;
}

export interface UpdateProductAttribute_updateProductAttribute {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  /**
   *  Az attribútumra lehet-e szűrni a termékeket
   */
  filterable: boolean | null;
  is_active: boolean | null;
  /**
   *  Az attribútum típusa
   */
  type: ProductAttributeType;
  options: UpdateProductAttribute_updateProductAttribute_options[] | null;
}

export interface UpdateProductAttribute {
  updateProductAttribute: UpdateProductAttribute_updateProductAttribute;
}

export interface UpdateProductAttributeVariables {
  id: string;
  name: string;
  code: string;
  filterable: boolean;
  is_active: boolean;
  type: ProductAttributeType;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateProductAttributeOption
// ====================================================

export interface updateProductAttributeOption_updateProductAttributeOption {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
  position: number | null;
  is_active: boolean;
  is_default: boolean;
}

export interface updateProductAttributeOption {
  updateProductAttributeOption: updateProductAttributeOption_updateProductAttributeOption | null;
}

export interface updateProductAttributeOptionVariables {
  id: string;
  label: string;
  is_active: boolean;
  is_default?: boolean | null;
  product_attribute_id: string;
  after?: string | null;
  before?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateProductCategory
// ====================================================

export interface updateProductCategory_updateProductCategory_children_children {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  product_count: number;
}

export interface updateProductCategory_updateProductCategory_children {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  children: updateProductCategory_updateProductCategory_children_children[] | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  is_homepage_prohibited: boolean;
  product_count: number;
}

export interface updateProductCategory_updateProductCategory {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  children: updateProductCategory_updateProductCategory_children[] | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  promotion_place: PromotionPlace | null;
  is_homepage_prohibited: boolean;
  product_count: number;
}

export interface updateProductCategory {
  updateProductCategory: updateProductCategory_updateProductCategory | null;
}

export interface updateProductCategoryVariables {
  id: string;
  name: string;
  parent_id?: number | null;
  url_key: string;
  content?: string | null;
  is_enable: boolean;
  date_to?: string | null;
  date_from?: string | null;
  show_in_menu: boolean;
  before?: number | null;
  after?: number | null;
  keywords?: string | null;
  description?: string | null;
  is_promotion: boolean;
  promotion_place?: PromotionPlace | null;
  is_homepage_prohibited?: boolean | null;
  products?: (string | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateProductListAd
// ====================================================

export interface updateProductListAd_updateProductListAd {
  __typename: "AdminProductListAd";
  id: string;
}

export interface updateProductListAd {
  updateProductListAd: updateProductListAd_updateProductListAd;
}

export interface updateProductListAdVariables {
  id: string;
  name: string;
  banner_url?: string | null;
  type: ProductListAdType;
  product_id?: string | null;
  image_url_desktop?: string | null;
  image_url_mobile?: string | null;
  is_active: boolean;
  active_from?: string | null;
  active_to?: string | null;
  urls: ProductListAdUrlInput[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateShippingMethod
// ====================================================

export interface UpdateShippingMethod_adminUpdateShippingMethod_price_ranges {
  __typename: "ShippingMethodPriceRange";
  from: number;
  price: number;
}

export interface UpdateShippingMethod_adminUpdateShippingMethod {
  __typename: "ShippingMethod";
  id: string;
  code: string;
  name: string;
  is_active: boolean;
  sort: number;
  price_ranges: UpdateShippingMethod_adminUpdateShippingMethod_price_ranges[] | null;
  discount_price: number | null;
  max_weight: number | null;
  description: string | null;
  short_description: string | null;
  delivery_time: string | null;
}

export interface UpdateShippingMethod {
  adminUpdateShippingMethod: UpdateShippingMethod_adminUpdateShippingMethod;
}

export interface UpdateShippingMethodVariables {
  id: string;
  name?: string | null;
  is_active?: boolean | null;
  before?: number | null;
  after?: number | null;
  price_ranges?: ShippingMethodPriceRangeInput[] | null;
  max_weight?: number | null;
  description?: string | null;
  short_description?: string | null;
  delivery_time?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateUrlAlias
// ====================================================

export interface updateUrlAlias_updateUrlAlias {
  __typename: "UrlAlias";
  id: string;
  source_url: string;
  target_url: string;
  created_at: any;
  updated_at: any | null;
}

export interface updateUrlAlias {
  updateUrlAlias: updateUrlAlias_updateUrlAlias;
}

export interface updateUrlAliasVariables {
  id: string;
  source_url: string;
  target_url: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateUser
// ====================================================

export interface updateUser_updateUser {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

export interface updateUser {
  updateUser: updateUser_updateUser;
}

export interface updateUserVariables {
  id: string;
  name?: string | null;
  email?: string | null;
  telephone?: string | null;
  default_billing_address?: string | null;
  default_shipping_address?: string | null;
  lyoness_card_number?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateUserPermissions
// ====================================================

export interface updateUserPermissions_updateUserPermissions {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

export interface updateUserPermissions {
  updateUserPermissions: updateUserPermissions_updateUserPermissions;
}

export interface updateUserPermissionsVariables {
  id: string;
  permissions: (Permission | null)[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateUserProductDiscount
// ====================================================

export interface updateUserProductDiscount_updateUserProductDiscount {
  __typename: "UserProductDiscount";
  id: string;
  user_id: string;
  is_active: boolean;
  active_from: any;
  active_to: any;
  created_at: any;
  updated_at: any;
}

export interface updateUserProductDiscount {
  updateUserProductDiscount: updateUserProductDiscount_updateUserProductDiscount | null;
}

export interface updateUserProductDiscountVariables {
  id: string;
  is_active: boolean;
  discount: number;
  active_from: string;
  active_to: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateUserShippingDiscount
// ====================================================

export interface updateUserShippingDiscount_updateUserShippingDiscount {
  __typename: "UserShippingDiscount";
  id: string;
  user_id: string;
  is_active: boolean;
  active_from: any;
  active_to: any;
  created_at: any;
  updated_at: any;
}

export interface updateUserShippingDiscount {
  updateUserShippingDiscount: updateUserShippingDiscount_updateUserShippingDiscount | null;
}

export interface updateUserShippingDiscountVariables {
  id: string;
  is_active: boolean;
  discount: number;
  active_from: string;
  active_to: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminBannerPlaces
// ====================================================

export interface adminBannerPlaces_adminBannerPlaces {
  __typename: "BannerPlace";
  id: string;
  name: string;
  type_id: BannerPlaceType;
}

export interface adminBannerPlaces {
  adminBannerPlaces: adminBannerPlaces_adminBannerPlaces[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminCmsAll
// ====================================================

export interface adminCmsAll_adminCmsContents_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface adminCmsAll_adminCmsContents_data {
  __typename: "AdminCmsContent";
  id: string;
  title: string;
  content: string | null;
  url_key: string;
  is_active: boolean;
  active_from: any | null;
  active_to: any | null;
  meta_title: string | null;
  meta_keywords: string | null;
  meta_description: string | null;
  created_at: any;
  updated_at: any | null;
}

export interface adminCmsAll_adminCmsContents {
  __typename: "AdminCmsContentPaginator";
  paginatorInfo: adminCmsAll_adminCmsContents_paginatorInfo;
  data: adminCmsAll_adminCmsContents_data[];
}

export interface adminCmsAll {
  adminCmsContents: adminCmsAll_adminCmsContents | null;
}

export interface adminCmsAllVariables {
  filters?: AdminCmsContentFilters | null;
  sortBy?: AdminCmsContentOrder | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminCmsList
// ====================================================

export interface adminCmsList_adminCmsContents_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface adminCmsList_adminCmsContents_data {
  __typename: "AdminCmsContent";
  id: string;
  title: string;
  url_key: string;
  is_active: boolean;
  active_from: any | null;
  active_to: any | null;
}

export interface adminCmsList_adminCmsContents {
  __typename: "AdminCmsContentPaginator";
  paginatorInfo: adminCmsList_adminCmsContents_paginatorInfo;
  data: adminCmsList_adminCmsContents_data[];
}

export interface adminCmsList {
  adminCmsContents: adminCmsList_adminCmsContents | null;
}

export interface adminCmsListVariables {
  filters?: AdminCmsContentFilters | null;
  sortBy?: AdminCmsContentOrder | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PaymentMethod
// ====================================================

export interface PaymentMethod_adminPaymentMethodById {
  __typename: "PaymentMethod";
  id: string;
  name: string;
  is_active: boolean;
  code: string;
  sort: number;
  short_description: string | null;
  short_description_mpl_type: string | null;
  cost: number;
}

export interface PaymentMethod {
  adminPaymentMethodById: PaymentMethod_adminPaymentMethodById | null;
}

export interface PaymentMethodVariables {
  id: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminPaymentMethodsList
// ====================================================

export interface AdminPaymentMethodsList_adminPaymentMethods {
  __typename: "PaymentMethod";
  id: string;
  name: string;
  is_active: boolean;
  sort: number;
  short_description: string | null;
  short_description_mpl_type: string | null;
  cost: number;
}

export interface AdminPaymentMethodsList {
  adminPaymentMethods: (AdminPaymentMethodsList_adminPaymentMethods | null)[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminProduct
// ====================================================

export interface adminProduct_adminProducts_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface adminProduct_adminProducts_data_categories {
  __typename: "ProductCategory";
  id: string;
  name: string;
}

export interface adminProduct_adminProducts_data_vote_calculated {
  __typename: "ProductVoteCalculated";
  /**
   * A termékre leadott szavazatok átlaga
   */
  vote_avg: number;
  vote_count_one: number;
  vote_count_two: number;
  vote_count_three: number;
  vote_count_four: number;
  vote_count_five: number;
}

export interface adminProduct_adminProducts_data_empties {
  __typename: "Product";
  id: string;
  name: string;
}

export interface adminProduct_adminProducts_data_attributes_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
}

export interface adminProduct_adminProducts_data_attributes {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  options: adminProduct_adminProducts_data_attributes_options[] | null;
}

export interface adminProduct_adminProducts_data_images_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface adminProduct_adminProducts_data_images {
  __typename: "ProductImage";
  id: string;
  url: string;
  conversions: adminProduct_adminProducts_data_images_conversions;
}

export interface adminProduct_adminProducts_data {
  __typename: "AdminProduct";
  id: string;
  /**
   *  ERP-ben használt id 
   */
  ext_id: number | null;
  /**
   * Régi webshop termék id
   */
  previous_id: string | null;
  name: string;
  /**
   * Termék státusza/elérhetősége
   */
  status: ProductStatus;
  /**
   * Új url
   */
  url_key: string | null;
  /**
   * Régi url
   */
  smarturl: string | null;
  categories: adminProduct_adminProducts_data_categories[] | null;
  default_category_id: number | null;
  price: number;
  /**
   * Az egységár egysége
   */
  price_unit: string | null;
  /**
   * Az egységár szorzója
   */
  price_per_unit: number | null;
  /**
   * Egységár
   */
  unit_price: number | null;
  /**
   * Akciós egységár
   */
  special_unit_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes ár 
   */
  personal_discount_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes egységár 
   */
  personal_discount_unit_price: number | null;
  /**
   * ÁFA
   */
  vat: number;
  /**
   * Akciós ár, bruttó
   */
  special_price: number | null;
  /**
   * Az akciós ár ettől a dátumtól érvényes
   */
  special_from_date: any | null;
  /**
   * Az akciós ár eeddig a dátumig érvényes
   */
  special_to_date: any | null;
  /**
   * Ettől a dátumtól "új" a termék
   */
  news_from_date: any | null;
  /**
   * Eddig a dátumig "új" a termék
   */
  news_to_date: any | null;
  /**
   * Leírás
   */
  description: string | null;
  /**
   * Összetevők leírása
   */
  components: string | null;
  /**
   * Tápanyaginformációk
   */
  nutrition_data: string | null;
  /**
   * A termékre leadott szavazatok aggregálva
   */
  vote_calculated: adminProduct_adminProducts_data_vote_calculated | null;
  /**
   * Prefixboxtól kapott terméknépszerűség szám
   */
  prefixbox_score: number | null;
  /**
   * Vonalkódok
   */
  barcodes: string[] | null;
  /**
   * Alternatív mennyiség neve
   */
  alternative_quantity_name: ProductAlternativeQuantityName | null;
  /**
   * Alternatív mennyiség legkisebb választható egsége
   */
  alternative_quantity_minimum: number | null;
  /**
   * Alternatív mennyiség léptetési egysége
   */
  alternative_quantity_scale: number | null;
  /**
   * Eredeti/alternatív egység átváltási arány
   */
  alternative_quantity_exchange_rate: number | null;
  /**
   * Alapértelmezett mennyiség neve
   */
  default_quantity_name: ProductDefaultQuantityName | null;
  /**
   * Alapértelmezett mennyiség legkisebb választható egysége
   */
  default_quantity_minimum: number | null;
  /**
   * Alapértelmezett mennyiség léptetési egysége
   */
  default_quantity_scale: number | null;
  /**
   * Nem egész mennyiség is kosárba rakható-e a termékből (alapértelmezett mennyiségre vonatkozik)
   */
  is_qty_decimal: boolean;
  /**
   * Ajándékkártyával rendelhető
   */
  gift_message_available: boolean;
  /**
   * Csomagfutárral (MPL) szállítható
   */
  is_mpl: boolean;
  meta_title: string | null;
  meta_description: string | null;
  meta_keywords: string | null;
  /**
   * Minimum szavatosság: x nap
   */
  min_expiry_days: number | null;
  /**
   * A termék tényleges tömege
   */
  package_official_g: number | null;
  /**
   * A termék tényleges űrtartalma
   */
  package_official_ml: number | null;
  /**
   * Szeletelve rendelhető
   */
  sliceable: boolean | null;
  /**
   * Tömeg grammban
   */
  weight: number;
  /**
   * Göngyöleg
   */
  empties: adminProduct_adminProducts_data_empties | null;
  /**
   *  A termékhez rendelt attribútumok és értékeik
   */
  attributes: adminProduct_adminProducts_data_attributes[] | null;
  /**
   * Termék képek
   */
  images: adminProduct_adminProducts_data_images[] | null;
  created_at: any;
  updated_at: any | null;
  /**
   * Internetes ár
   */
  webshop_only_price: boolean;
}

export interface adminProduct_adminProducts {
  __typename: "AdminProductPaginator";
  paginatorInfo: adminProduct_adminProducts_paginatorInfo;
  data: adminProduct_adminProducts_data[];
}

export interface adminProduct {
  adminProducts: adminProduct_adminProducts | null;
}

export interface adminProductVariables {
  filters?: AdminProductFilters | null;
  sortBy?: AdminProductOrder | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminProductAttributeList
// ====================================================

export interface AdminProductAttributeList_adminProductAttributes {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  /**
   *  Az attribútumra lehet-e szűrni a termékeket
   */
  filterable: boolean | null;
  is_active: boolean | null;
  /**
   *  Az attribútum típusa
   */
  type: ProductAttributeType;
}

export interface AdminProductAttributeList {
  adminProductAttributes: AdminProductAttributeList_adminProductAttributes[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminProductAttributeListWithOptions
// ====================================================

export interface AdminProductAttributeListWithOptions_adminProductAttributes_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
  position: number | null;
  is_active: boolean;
  is_default: boolean;
}

export interface AdminProductAttributeListWithOptions_adminProductAttributes {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  /**
   *  Az attribútumra lehet-e szűrni a termékeket
   */
  filterable: boolean | null;
  is_active: boolean | null;
  /**
   *  Az attribútum típusa
   */
  type: ProductAttributeType;
  options: AdminProductAttributeListWithOptions_adminProductAttributes_options[] | null;
}

export interface AdminProductAttributeListWithOptions {
  adminProductAttributes: AdminProductAttributeListWithOptions_adminProductAttributes[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminProductCategoryList
// ====================================================

export interface AdminProductCategoryList_adminProductCategories_children_children {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  product_count: number;
}

export interface AdminProductCategoryList_adminProductCategories_children {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  children: AdminProductCategoryList_adminProductCategories_children_children[] | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  is_homepage_prohibited: boolean;
  product_count: number;
}

export interface AdminProductCategoryList_adminProductCategories {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  children: AdminProductCategoryList_adminProductCategories_children[] | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  promotion_place: PromotionPlace | null;
  is_homepage_prohibited: boolean;
  product_count: number;
}

export interface AdminProductCategoryList {
  adminProductCategories: AdminProductCategoryList_adminProductCategories[];
}

export interface AdminProductCategoryListVariables {
  parent_id?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminProductList
// ====================================================

export interface adminProductList_adminProducts_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface adminProductList_adminProducts_data_categories {
  __typename: "ProductCategory";
  id: string;
  name: string;
}

export interface adminProductList_adminProducts_data {
  __typename: "AdminProduct";
  id: string;
  /**
   *  ERP-ben használt id 
   */
  ext_id: number | null;
  name: string;
  /**
   * Termék státusza/elérhetősége
   */
  status: ProductStatus;
  price: number;
  /**
   * Akciós ár, bruttó
   */
  special_price: number | null;
  /**
   * Az akciós ár ettől a dátumtól érvényes
   */
  special_from_date: any | null;
  /**
   * Az akciós ár eeddig a dátumig érvényes
   */
  special_to_date: any | null;
  /**
   * Ettől a dátumtól "új" a termék
   */
  news_from_date: any | null;
  /**
   * Eddig a dátumig "új" a termék
   */
  news_to_date: any | null;
  categories: adminProductList_adminProducts_data_categories[] | null;
  /**
   * Csomagfutárral (MPL) szállítható
   */
  is_mpl: boolean;
}

export interface adminProductList_adminProducts {
  __typename: "AdminProductPaginator";
  paginatorInfo: adminProductList_adminProducts_paginatorInfo;
  data: adminProductList_adminProducts_data[];
}

export interface adminProductList {
  adminProducts: adminProductList_adminProducts | null;
}

export interface adminProductListVariables {
  filters?: AdminProductFilters | null;
  sortBy?: AdminProductOrder | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminProductListAd
// ====================================================

export interface adminProductListAd_adminProductListAd_product {
  __typename: "AdminProduct";
  id: string;
  name: string;
}

export interface adminProductListAd_adminProductListAd_urls {
  __typename: "ProductListAdUrl";
  url: string;
  position: number;
}

export interface adminProductListAd_adminProductListAd {
  __typename: "AdminProductListAd";
  id: string;
  name: string;
  banner_url: string | null;
  type: ProductListAdType;
  product: adminProductListAd_adminProductListAd_product | null;
  image_url_desktop: string | null;
  image_url_mobile: string | null;
  urls: adminProductListAd_adminProductListAd_urls[] | null;
  is_active: boolean;
  active_from: any | null;
  active_to: any | null;
}

export interface adminProductListAd {
  adminProductListAd: adminProductListAd_adminProductListAd | null;
}

export interface adminProductListAdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminProductListAdsQuery
// ====================================================

export interface adminProductListAdsQuery_adminProductListAds_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface adminProductListAdsQuery_adminProductListAds_data_urls {
  __typename: "ProductListAdUrl";
  url: string;
}

export interface adminProductListAdsQuery_adminProductListAds_data {
  __typename: "AdminProductListAd";
  id: string;
  name: string;
  type: ProductListAdType;
  image_url_desktop: string | null;
  image_url_mobile: string | null;
  urls: adminProductListAdsQuery_adminProductListAds_data_urls[] | null;
  is_active: boolean;
  active_from: any | null;
  active_to: any | null;
  created_at: any;
  updated_at: any | null;
}

export interface adminProductListAdsQuery_adminProductListAds {
  __typename: "AdminProductListAdPaginator";
  paginatorInfo: adminProductListAdsQuery_adminProductListAds_paginatorInfo;
  data: adminProductListAdsQuery_adminProductListAds_data[];
}

export interface adminProductListAdsQuery {
  adminProductListAds: adminProductListAdsQuery_adminProductListAds | null;
}

export interface adminProductListAdsQueryVariables {
  filters?: AdminProductListAdFilter | null;
  sortBy?: AdminProductListAdOrder | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminPromotionCategoryList
// ====================================================

export interface AdminPromotionCategoryList_adminPromotionCategories {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  promotion_place: PromotionPlace | null;
  is_homepage_prohibited: boolean;
}

export interface AdminPromotionCategoryList {
  adminPromotionCategories: AdminPromotionCategoryList_adminPromotionCategories[];
}

export interface AdminPromotionCategoryListVariables {
  promotion_places?: PromotionPlace[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ShippingMethod
// ====================================================

export interface ShippingMethod_adminShippingMethodById_price_ranges {
  __typename: "ShippingMethodPriceRange";
  from: number;
  price: number;
}

export interface ShippingMethod_adminShippingMethodById {
  __typename: "ShippingMethod";
  id: string;
  code: string;
  name: string;
  is_active: boolean;
  sort: number;
  price_ranges: ShippingMethod_adminShippingMethodById_price_ranges[] | null;
  discount_price: number | null;
  max_weight: number | null;
  description: string | null;
  short_description: string | null;
  delivery_time: string | null;
}

export interface ShippingMethod {
  adminShippingMethodById: ShippingMethod_adminShippingMethodById | null;
}

export interface ShippingMethodVariables {
  id: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminShippingMethodsList
// ====================================================

export interface AdminShippingMethodsList_adminShippingMethods_price_ranges {
  __typename: "ShippingMethodPriceRange";
  from: number;
  price: number;
}

export interface AdminShippingMethodsList_adminShippingMethods {
  __typename: "ShippingMethod";
  id: string;
  code: string;
  name: string;
  is_active: boolean;
  sort: number;
  price_ranges: AdminShippingMethodsList_adminShippingMethods_price_ranges[] | null;
  discount_price: number | null;
  max_weight: number | null;
  description: string | null;
  short_description: string | null;
  delivery_time: string | null;
}

export interface AdminShippingMethodsList {
  adminShippingMethods: (AdminShippingMethodsList_adminShippingMethods | null)[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminTimetableSectors
// ====================================================

export interface adminTimetableSectors_adminTimetableSectors {
  __typename: "TimetableSector";
  id: string;
  name: string;
}

export interface adminTimetableSectors {
  adminTimetableSectors: adminTimetableSectors_adminTimetableSectors[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminTimetableSlotsList
// ====================================================

export interface AdminTimetableSlotsList_adminTimetableTimeSlots_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface AdminTimetableSlotsList_adminTimetableTimeSlots_data_sector {
  __typename: "TimetableSector";
  id: string;
  name: string;
}

export interface AdminTimetableSlotsList_adminTimetableTimeSlots_data_timeRange {
  __typename: "TimetableTimeRange";
  id: string;
  time_from: string;
  time_to: string;
}

export interface AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders_status {
  __typename: "OrderStatus";
  code: OrderStatusCode;
}

export interface AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders_parent_order {
  __typename: "Order";
  id: string;
}

export interface AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders {
  __typename: "Order";
  id: string;
  shipping_postcode: string;
  status: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders_status;
  parent_order: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders_parent_order | null;
}

export interface AdminTimetableSlotsList_adminTimetableTimeSlots_data {
  __typename: "TimetableTimeSlot";
  id: string;
  sector: AdminTimetableSlotsList_adminTimetableTimeSlots_data_sector;
  order_limit: number;
  weight_limit: number;
  price: number;
  range_date: any;
  timeRange: AdminTimetableSlotsList_adminTimetableTimeSlots_data_timeRange;
  visible_until: any;
  status: TimetableTimeSlotStatusType;
  reserved_order_count: number;
  reserved_weight_count: number;
  orders: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders[];
}

export interface AdminTimetableSlotsList_adminTimetableTimeSlots {
  __typename: "TimetableTimeSlotPaginator";
  paginatorInfo: AdminTimetableSlotsList_adminTimetableTimeSlots_paginatorInfo;
  data: AdminTimetableSlotsList_adminTimetableTimeSlots_data[];
}

export interface AdminTimetableSlotsList {
  adminTimetableTimeSlots: AdminTimetableSlotsList_adminTimetableTimeSlots | null;
}

export interface AdminTimetableSlotsListVariables {
  filters?: TimetableTimeSlotsFilters | null;
  sortBy?: TimetableTimeSlotsOrder | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminUser
// ====================================================

export interface adminUser_listAdmins_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface adminUser_listAdmins_data {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

export interface adminUser_listAdmins {
  __typename: "UserPaginator";
  paginatorInfo: adminUser_listAdmins_paginatorInfo;
  data: adminUser_listAdmins_data[];
}

export interface adminUser {
  listAdmins: adminUser_listAdmins | null;
}

export interface adminUserVariables {
  filters?: UserFilters | null;
  sortBy?: UserSort | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminUserList
// ====================================================

export interface adminUserList_listAdmins_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface adminUserList_listAdmins_data_shipping_addresses {
  __typename: "UserShippingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  note: string | null;
  telephone: string | null;
  is_goodid: boolean;
}

export interface adminUserList_listAdmins_data_orders_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface adminUserList_listAdmins_data_orders {
  __typename: "OrderPaginator";
  paginatorInfo: adminUserList_listAdmins_data_orders_paginatorInfo;
}

export interface adminUserList_listAdmins_data {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  telephone: string | null;
  ext_id: string;
  last_login: any | null;
  ip_address: string | null;
  shipping_addresses: adminUserList_listAdmins_data_shipping_addresses[] | null;
  orders: adminUserList_listAdmins_data_orders | null;
}

export interface adminUserList_listAdmins {
  __typename: "UserPaginator";
  paginatorInfo: adminUserList_listAdmins_paginatorInfo;
  data: adminUserList_listAdmins_data[];
}

export interface adminUserList {
  listAdmins: adminUserList_listAdmins | null;
}

export interface adminUserListVariables {
  filters?: UserFilters | null;
  sortBy?: UserSort | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminUserName
// ====================================================

export interface adminUserName_listUsers_data {
  __typename: "User";
  name: string;
}

export interface adminUserName_listUsers {
  __typename: "UserPaginator";
  data: adminUserName_listUsers_data[];
}

export interface adminUserName {
  listUsers: adminUserName_listUsers | null;
}

export interface adminUserNameVariables {
  filters?: UserFilters | null;
  sortBy?: UserSort | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: bannerList
// ====================================================

export interface bannerList_adminBanners_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface bannerList_adminBanners_data_banner_places {
  __typename: "BannerPlace";
  id: string;
  name: string;
}

export interface bannerList_adminBanners_data {
  __typename: "AdminBanner";
  id: string;
  name: string;
  active_from: any | null;
  active_to: any | null;
  is_active: boolean;
  banner_places: bannerList_adminBanners_data_banner_places[];
}

export interface bannerList_adminBanners {
  __typename: "AdminBannerPaginator";
  paginatorInfo: bannerList_adminBanners_paginatorInfo;
  data: bannerList_adminBanners_data[];
}

export interface bannerList {
  adminBanners: bannerList_adminBanners | null;
}

export interface bannerListVariables {
  filters?: AdminBannerFilters | null;
  sortBy?: AdminBannerOrder | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: bannerListAll
// ====================================================

export interface bannerListAll_adminBanners_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface bannerListAll_adminBanners_data_banner_places {
  __typename: "BannerPlace";
  id: string;
  name: string;
  type_id: BannerPlaceType;
}

export interface bannerListAll_adminBanners_data {
  __typename: "AdminBanner";
  id: string;
  name: string;
  active_from: any | null;
  active_to: any | null;
  url: string;
  url_target: BannerUrlTarget;
  image_url_desktop: string;
  image_url_mobile: string;
  is_active: boolean;
  priority: number;
  created_at: any;
  updated_at: any | null;
  banner_places: bannerListAll_adminBanners_data_banner_places[];
}

export interface bannerListAll_adminBanners {
  __typename: "AdminBannerPaginator";
  paginatorInfo: bannerListAll_adminBanners_paginatorInfo;
  data: bannerListAll_adminBanners_data[];
}

export interface bannerListAll {
  adminBanners: bannerListAll_adminBanners | null;
}

export interface bannerListAllVariables {
  filters?: AdminBannerFilters | null;
  sortBy?: AdminBannerOrder | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: coupon
// ====================================================

export interface coupon_coupon_price_ranges {
  __typename: "CouponPriceRange";
  from: number;
  discount: number;
}

export interface coupon_coupon_shipping_method {
  __typename: "ShippingMethod";
  id: string;
}

export interface coupon_coupon_payment_method {
  __typename: "PaymentMethod";
  id: string;
}

export interface coupon_coupon_codes_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface coupon_coupon_codes_data {
  __typename: "CouponCode";
  code: string;
  /**
   *  Ennyiszer használható fel a kuponkód 
   */
  usage_count: number;
}

export interface coupon_coupon_codes {
  __typename: "CouponCodePaginator";
  paginatorInfo: coupon_coupon_codes_paginatorInfo;
  data: coupon_coupon_codes_data[];
}

export interface coupon_coupon_products_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface coupon_coupon_products_data_categories {
  __typename: "ProductCategory";
  id: string;
  name: string;
}

export interface coupon_coupon_products_data_vote_calculated {
  __typename: "ProductVoteCalculated";
  /**
   * A termékre leadott szavazatok átlaga
   */
  vote_avg: number;
  vote_count_one: number;
  vote_count_two: number;
  vote_count_three: number;
  vote_count_four: number;
  vote_count_five: number;
}

export interface coupon_coupon_products_data_attributes_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
}

export interface coupon_coupon_products_data_attributes {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  options: coupon_coupon_products_data_attributes_options[] | null;
}

export interface coupon_coupon_products_data_images_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface coupon_coupon_products_data_images {
  __typename: "ProductImage";
  id: string;
  is_default: boolean;
  url: string;
  conversions: coupon_coupon_products_data_images_conversions;
}

export interface coupon_coupon_products_data {
  __typename: "Product";
  id: string;
  /**
   *  ERP-ben használt id, az olyan termékeknél null, amik nincsenek meg az ERP-ben, de a rendelésekkel áthoztuk 
   */
  ext_id: number | null;
  /**
   * Régi webshop termék id
   */
  previous_id: string | null;
  name: string;
  /**
   * Termék státusza/elérhetősége
   */
  status: ProductStatus;
  /**
   * Új url
   */
  url_key: string | null;
  /**
   * Régi url
   */
  smarturl: string | null;
  categories: coupon_coupon_products_data_categories[] | null;
  default_category_id: number | null;
  price: number;
  /**
   * Az egységár egysége
   */
  price_unit: string | null;
  /**
   * Az egységár szorzója
   */
  price_per_unit: number | null;
  /**
   * Egységár
   */
  unit_price: number | null;
  /**
   * Akciós egységár
   */
  special_unit_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes ár 
   */
  personal_discount_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes egységár 
   */
  personal_discount_unit_price: number | null;
  /**
   * ÁFA
   */
  vat: number;
  /**
   * Akciós ár, bruttó
   */
  special_price: number | null;
  /**
   * Az akciós ár ettől a dátumtól érvényes
   */
  special_from_date: any | null;
  /**
   * Az akciós ár eeddig a dátumig érvényes
   */
  special_to_date: any | null;
  /**
   * Ettől a dátumtól "új" a termék
   */
  news_from_date: any | null;
  /**
   * Eddig a dátumig "új" a termék
   */
  news_to_date: any | null;
  /**
   * A termékre leadott szavazatok aggregálva
   */
  vote_calculated: coupon_coupon_products_data_vote_calculated | null;
  /**
   * Leírás
   */
  description: string | null;
  /**
   * Összetevők leírása
   */
  components: string | null;
  /**
   * Tápanyaginformációk
   */
  nutrition_data: string | null;
  /**
   * Prefixboxtól kapott terméknépszerűség szám
   */
  prefixbox_score: number | null;
  /**
   * Vonalkódok
   */
  barcodes: string[] | null;
  /**
   * Alternatív mennyiség neve
   */
  alternative_quantity_name: ProductAlternativeQuantityName | null;
  /**
   * Alternatív mennyiség legkisebb választható egsége
   */
  alternative_quantity_minimum: number | null;
  /**
   * Alternatív mennyiség léptetési egysége
   */
  alternative_quantity_scale: number | null;
  /**
   * Eredeti/alternatív egység átváltási arány
   */
  alternative_quantity_exchange_rate: number | null;
  /**
   * Alapértelmezett mennyiség neve
   */
  default_quantity_name: ProductDefaultQuantityName | null;
  /**
   * Alapértelmezett mennyiség legkisebb választható egysége
   */
  default_quantity_minimum: number | null;
  /**
   * Alapértelmezett mennyiség léptetési egysége
   */
  default_quantity_scale: number | null;
  /**
   * Nem egész mennyiség is kosárba rakható-e a termékből (alapértelmezett mennyiségre vonatkozik)
   */
  is_qty_decimal: boolean;
  /**
   * Ajándékkártyával rendelhető
   */
  gift_message_available: boolean;
  /**
   * Csomagfutárral (MPL) szállítható
   */
  is_mpl: boolean;
  meta_title: string | null;
  meta_description: string | null;
  meta_keywords: string | null;
  /**
   * Minimum szavatosság: x nap
   */
  min_expiry_days: number | null;
  /**
   * A termék tényleges tömege
   */
  package_official_g: number | null;
  /**
   * A termék tényleges űrtartalma
   */
  package_official_ml: number | null;
  /**
   * Szeletelve rendelhető
   */
  sliceable: boolean | null;
  /**
   * Tömeg grammban
   */
  weight: number;
  /**
   *  A termékhez rendelt attribútumok és értékeik
   */
  attributes: coupon_coupon_products_data_attributes[] | null;
  /**
   * Termék képek
   */
  images: coupon_coupon_products_data_images[] | null;
  is_subscribed: boolean;
  created_at: any;
  updated_at: any | null;
}

export interface coupon_coupon_products {
  __typename: "ProductPaginator";
  paginatorInfo: coupon_coupon_products_paginatorInfo;
  data: coupon_coupon_products_data[];
}

export interface coupon_coupon {
  __typename: "Coupon";
  id: string;
  name: string;
  description: string | null;
  active_from: any;
  active_to: any;
  type: CouponType;
  /**
   *  Mire érvényes: termék, szállítás 
   */
  applied_to: CouponAppliedTo;
  /**
   *  + ingyen szállítás? 
   */
  is_free_shipping: boolean;
  /**
   *  Generált kuponkódok száma 
   */
  generated_codes_count: number;
  /**
   *  Felhasznált kuponkódok száma 
   */
  used_codes_count: number;
  price_ranges: coupon_coupon_price_ranges[];
  is_active: boolean;
  /**
   *  Milyen szállítási módra érvényes 
   */
  shipping_method: coupon_coupon_shipping_method | null;
  /**
   *  Milyen fizetési módra érvényes 
   */
  payment_method: coupon_coupon_payment_method | null;
  /**
   *  Ennyiszer haszálhatóak fel a kuponhoz tartozó kódok 
   */
  usage_count: number;
  /**
   *  Más kedvezménnyel összevonható? 
   */
  is_combinable: boolean;
  codes: coupon_coupon_codes | null;
  products: coupon_coupon_products | null;
}

export interface coupon {
  coupon: coupon_coupon | null;
}

export interface couponVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: coupons
// ====================================================

export interface coupons_coupons_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface coupons_coupons_data_codes_data {
  __typename: "CouponCode";
  /**
   *  Ennyiszer használható fel a kuponkód 
   */
  usage_count: number;
}

export interface coupons_coupons_data_codes {
  __typename: "CouponCodePaginator";
  data: coupons_coupons_data_codes_data[];
}

export interface coupons_coupons_data {
  __typename: "Coupon";
  id: string;
  name: string;
  active_from: any;
  active_to: any;
  type: CouponType;
  /**
   *  Mire érvényes: termék, szállítás 
   */
  applied_to: CouponAppliedTo;
  /**
   *  + ingyen szállítás? 
   */
  is_free_shipping: boolean;
  is_active: boolean;
  /**
   *  Ennyiszer haszálhatóak fel a kuponhoz tartozó kódok 
   */
  usage_count: number;
  /**
   *  Más kedvezménnyel összevonható? 
   */
  is_combinable: boolean;
  created_at: any;
  updated_at: any | null;
  /**
   *  Generált kuponkódok száma 
   */
  generated_codes_count: number;
  /**
   *  Felhasznált kuponkódok száma 
   */
  used_codes_count: number;
  codes: coupons_coupons_data_codes | null;
}

export interface coupons_coupons {
  __typename: "CouponPaginator";
  paginatorInfo: coupons_coupons_paginatorInfo;
  data: coupons_coupons_data[];
}

export interface coupons {
  coupons: coupons_coupons | null;
}

export interface couponsVariables {
  filters?: AdminCouponsFilter | null;
  sortBy?: AdminCouponOrder | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: donation
// ====================================================

export interface donation_donation {
  __typename: "AdminDonation";
  name: string;
  cms_url: string;
  active_from: any;
  active_to: any;
  donation_total: number | null;
  round_donated_count: number;
  unique_donated_count: number;
  not_donated_count: number;
  dismissed_count: number;
}

export interface donation {
  donation: donation_donation | null;
}

export interface donationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: donations
// ====================================================

export interface donations_donations_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface donations_donations_data {
  __typename: "AdminDonation";
  id: string;
  name: string;
  active_from: any;
  active_to: any;
  cms_url: string;
  donation_total: number | null;
}

export interface donations_donations {
  __typename: "AdminDonationPaginator";
  paginatorInfo: donations_donations_paginatorInfo;
  data: donations_donations_data[];
}

export interface donations {
  donations: donations_donations | null;
}

export interface donationsVariables {
  filters?: AdminDonationsFilter | null;
  sortBy?: AdminDonationsOrder | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getAdminMinioCredentials
// ====================================================

export interface getAdminMinioCredentials_getAdminMinioCredentials {
  __typename: "AdminMinioCredentials";
  minio_access_key: string | null;
  minio_secret_key: string | null;
  minio_endpoint: string | null;
  minio_bucket: string | null;
}

export interface getAdminMinioCredentials {
  getAdminMinioCredentials: getAdminMinioCredentials_getAdminMinioCredentials | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getAllUrlAlias
// ====================================================

export interface getAllUrlAlias_getAllUrlAlias {
  __typename: "UrlAlias";
  id: string;
  source_url: string;
  target_url: string;
  created_at: any;
  updated_at: any | null;
}

export interface getAllUrlAlias {
  getAllUrlAlias: getAllUrlAlias_getAllUrlAlias[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getUrlAlias
// ====================================================

export interface getUrlAlias_getUrlAlias {
  __typename: "UrlAlias";
  id: string;
  source_url: string;
  target_url: string;
  created_at: any;
  updated_at: any | null;
}

export interface getUrlAlias {
  getUrlAlias: getUrlAlias_getUrlAlias | null;
}

export interface getUrlAliasVariables {
  source_url?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: me
// ====================================================

export interface me_me {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

export interface me {
  me: me_me | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Order
// ====================================================

export interface Order_orders_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface Order_orders_data_timetable_time_slot_sector {
  __typename: "TimetableSector";
  name: string;
}

export interface Order_orders_data_timetable_time_slot_timeRange {
  __typename: "TimetableTimeRange";
  time_from: string;
  time_to: string;
}

export interface Order_orders_data_timetable_time_slot {
  __typename: "TimetableTimeSlot";
  id: string;
  sector: Order_orders_data_timetable_time_slot_sector;
  range_date: any;
  timeRange: Order_orders_data_timetable_time_slot_timeRange;
}

export interface Order_orders_data_post_point {
  __typename: "PostPoint";
  id: string;
  name: string;
  ext_id: string;
  postcode: number;
  city: string;
  street_name: string | null;
  street_type: string | null;
  house_number: string | null;
  latitude: number;
  longitude: number;
  service_point_type: string | null;
  working_hours: any | null;
}

export interface Order_orders_data_shipping_method {
  __typename: "ShippingMethod";
  id: string;
  name: string;
}

export interface Order_orders_data_payment_method {
  __typename: "PaymentMethod";
  id: string;
  name: string;
}

export interface Order_orders_data_user {
  __typename: "User";
  id: string;
  name: string;
}

export interface Order_orders_data_order_products_product {
  __typename: "Product";
  id: string;
  name: string;
  /**
   * Tömeg grammban
   */
  weight: number;
}

export interface Order_orders_data_order_products {
  __typename: "OrderProduct";
  price: number;
  special_price: number | null;
  default_quantity_name: string;
  default_quantity_piece: number;
  alternative_quantity_name: string | null;
  alternative_quantity_piece: number | null;
  product: Order_orders_data_order_products_product;
  sliced: boolean | null;
  additional_information: string | null;
}

export interface Order_orders_data_status {
  __typename: "OrderStatus";
  title: string;
  code: OrderStatusCode;
}

export interface Order_orders_data_coupon_data {
  __typename: "OrderCouponData";
  name: string;
  code: string;
  product_discount: number | null;
  shipping_discount: number | null;
}

export interface Order_orders_data_linked_orders {
  __typename: "Order";
  id: string;
}

export interface Order_orders_data_parent_order {
  __typename: "Order";
  id: string;
}

export interface Order_orders_data_contact_data {
  __typename: "ContactPersonData";
  contact_name: string;
  contact_email: string;
  contact_telephone: string;
}

export interface Order_orders_data_donation_data {
  __typename: "OrderDonation";
  /**
   *  Az adakozás típusa (kerekített vagy egyedi összeg) 
   */
  type: OrderDonationType;
  /**
   *  Az adomány összege 
   */
  amount: number;
}

export interface Order_orders_data {
  __typename: "Order";
  id: string;
  total_amount: number;
  total_sum: number;
  shipping_cost: number;
  timetable_time_slot: Order_orders_data_timetable_time_slot | null;
  post_point: Order_orders_data_post_point | null;
  shipping_method: Order_orders_data_shipping_method;
  payment_method: Order_orders_data_payment_method;
  shipping_name: string;
  shipping_postcode: string;
  shipping_city: string;
  shipping_street: string;
  shipping_house_number: string;
  shipping_telephone: string;
  shipping_note: string | null;
  billing_name: string;
  billing_postcode: string;
  billing_city: string;
  billing_street: string;
  billing_house_number: string;
  vat_number: string | null;
  is_company: boolean | null;
  user: Order_orders_data_user | null;
  comment: string | null;
  lyoness_card_number: string | null;
  order_products: Order_orders_data_order_products[];
  status: Order_orders_data_status;
  coupon_data: Order_orders_data_coupon_data | null;
  linked_orders: (Order_orders_data_linked_orders | null)[] | null;
  parent_order: Order_orders_data_parent_order | null;
  created_at: any;
  contact_data: Order_orders_data_contact_data | null;
  erp_comment: string | null;
  admin_id: string | null;
  donation_data: Order_orders_data_donation_data | null;
  payment_method_cost: number;
}

export interface Order_orders {
  __typename: "OrderPaginator";
  paginatorInfo: Order_orders_paginatorInfo;
  data: Order_orders_data[];
}

export interface Order {
  orders: Order_orders | null;
}

export interface OrderVariables {
  filters?: OrderFilters | null;
  sortBy?: OrderSort | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Orders
// ====================================================

export interface Orders_orders_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface Orders_orders_data_user_orders_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface Orders_orders_data_user_orders {
  __typename: "OrderPaginator";
  paginatorInfo: Orders_orders_data_user_orders_paginatorInfo;
}

export interface Orders_orders_data_user {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  ext_id: string;
  orders: Orders_orders_data_user_orders | null;
}

export interface Orders_orders_data_contact_data {
  __typename: "ContactPersonData";
  contact_name: string;
  contact_email: string;
  contact_telephone: string;
}

export interface Orders_orders_data_status {
  __typename: "OrderStatus";
  title: string;
  code: OrderStatusCode;
}

export interface Orders_orders_data_shipping_method {
  __typename: "ShippingMethod";
  id: string;
  name: string;
}

export interface Orders_orders_data {
  __typename: "Order";
  id: string;
  created_at: any;
  user: Orders_orders_data_user | null;
  contact_data: Orders_orders_data_contact_data | null;
  total_amount: number;
  total_sum: number;
  status: Orders_orders_data_status;
  shipping_method: Orders_orders_data_shipping_method;
  is_admin_checked: boolean | null;
  /**
   *  A kapcsolt rendelés (parent_order) id-ja 
   */
  linked_order_id: string | null;
}

export interface Orders_orders {
  __typename: "OrderPaginator";
  paginatorInfo: Orders_orders_paginatorInfo;
  data: Orders_orders_data[];
}

export interface Orders {
  orders: Orders_orders | null;
}

export interface OrdersVariables {
  filters?: OrderFilters | null;
  sortBy?: OrderSort | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: orderStatuses
// ====================================================

export interface orderStatuses_orderStatuses {
  __typename: "OrderStatus";
  id: number;
  title: string;
  code: OrderStatusCode;
}

export interface orderStatuses {
  orderStatuses: orderStatuses_orderStatuses[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: orderUpdateLogs
// ====================================================

export interface orderUpdateLogs_orderUpdateLogs_original_timetable_time_slot_sector {
  __typename: "TimetableSector";
  name: string;
}

export interface orderUpdateLogs_orderUpdateLogs_original_timetable_time_slot_timeRange {
  __typename: "TimetableTimeRange";
  time_from: string;
  time_to: string;
}

export interface orderUpdateLogs_orderUpdateLogs_original_timetable_time_slot {
  __typename: "TimetableTimeSlot";
  sector: orderUpdateLogs_orderUpdateLogs_original_timetable_time_slot_sector;
  range_date: any;
  timeRange: orderUpdateLogs_orderUpdateLogs_original_timetable_time_slot_timeRange;
}

export interface orderUpdateLogs_orderUpdateLogs_original_post_point {
  __typename: "PostPoint";
  id: string;
}

export interface orderUpdateLogs_orderUpdateLogs_original_shipping_method {
  __typename: "ShippingMethod";
  id: string;
}

export interface orderUpdateLogs_orderUpdateLogs_original_payment_method {
  __typename: "PaymentMethod";
  id: string;
}

export interface orderUpdateLogs_orderUpdateLogs_original_linked_order {
  __typename: "Order";
  id: string;
}

export interface orderUpdateLogs_orderUpdateLogs_original_status {
  __typename: "OrderStatus";
  title: string;
}

export interface orderUpdateLogs_orderUpdateLogs_original {
  __typename: "OrderUpdateLogData";
  synchronized: boolean | null;
  total_amount: number | null;
  shipping_cost: number | null;
  timetable_time_slot: orderUpdateLogs_orderUpdateLogs_original_timetable_time_slot | null;
  post_point: orderUpdateLogs_orderUpdateLogs_original_post_point | null;
  shipping_method: orderUpdateLogs_orderUpdateLogs_original_shipping_method | null;
  payment_method: orderUpdateLogs_orderUpdateLogs_original_payment_method | null;
  linked_order: orderUpdateLogs_orderUpdateLogs_original_linked_order | null;
  comment: string | null;
  status: orderUpdateLogs_orderUpdateLogs_original_status | null;
  is_admin_checked: boolean | null;
  admin_id: string | null;
}

export interface orderUpdateLogs_orderUpdateLogs_new_timetable_time_slot_sector {
  __typename: "TimetableSector";
  name: string;
}

export interface orderUpdateLogs_orderUpdateLogs_new_timetable_time_slot_timeRange {
  __typename: "TimetableTimeRange";
  time_from: string;
  time_to: string;
}

export interface orderUpdateLogs_orderUpdateLogs_new_timetable_time_slot {
  __typename: "TimetableTimeSlot";
  sector: orderUpdateLogs_orderUpdateLogs_new_timetable_time_slot_sector;
  range_date: any;
  timeRange: orderUpdateLogs_orderUpdateLogs_new_timetable_time_slot_timeRange;
}

export interface orderUpdateLogs_orderUpdateLogs_new_post_point {
  __typename: "PostPoint";
  id: string;
}

export interface orderUpdateLogs_orderUpdateLogs_new_shipping_method {
  __typename: "ShippingMethod";
  id: string;
}

export interface orderUpdateLogs_orderUpdateLogs_new_payment_method {
  __typename: "PaymentMethod";
  id: string;
}

export interface orderUpdateLogs_orderUpdateLogs_new_linked_order {
  __typename: "Order";
  id: string;
}

export interface orderUpdateLogs_orderUpdateLogs_new_status {
  __typename: "OrderStatus";
  title: string;
}

export interface orderUpdateLogs_orderUpdateLogs_new {
  __typename: "OrderUpdateLogData";
  synchronized: boolean | null;
  total_amount: number | null;
  shipping_cost: number | null;
  timetable_time_slot: orderUpdateLogs_orderUpdateLogs_new_timetable_time_slot | null;
  post_point: orderUpdateLogs_orderUpdateLogs_new_post_point | null;
  shipping_method: orderUpdateLogs_orderUpdateLogs_new_shipping_method | null;
  payment_method: orderUpdateLogs_orderUpdateLogs_new_payment_method | null;
  linked_order: orderUpdateLogs_orderUpdateLogs_new_linked_order | null;
  comment: string | null;
  status: orderUpdateLogs_orderUpdateLogs_new_status | null;
  is_admin_checked: boolean | null;
  admin_id: string | null;
}

export interface orderUpdateLogs_orderUpdateLogs {
  __typename: "OrderUpdateLogResult";
  modified_by_erp: boolean;
  erp_admin_name: string | null;
  original: orderUpdateLogs_orderUpdateLogs_original | null;
  new: orderUpdateLogs_orderUpdateLogs_new | null;
  created_at: any;
}

export interface orderUpdateLogs {
  orderUpdateLogs: orderUpdateLogs_orderUpdateLogs[] | null;
}

export interface orderUpdateLogsVariables {
  order_id: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Product
// ====================================================

export interface Product_product_categories {
  __typename: "ProductCategory";
  id: string;
  name: string;
}

export interface Product_product_vote_calculated {
  __typename: "ProductVoteCalculated";
  /**
   * A termékre leadott szavazatok átlaga
   */
  vote_avg: number;
  vote_count_one: number;
  vote_count_two: number;
  vote_count_three: number;
  vote_count_four: number;
  vote_count_five: number;
}

export interface Product_product_attributes_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
}

export interface Product_product_attributes {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  options: Product_product_attributes_options[] | null;
}

export interface Product_product_images_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface Product_product_images {
  __typename: "ProductImage";
  id: string;
  is_default: boolean;
  url: string;
  conversions: Product_product_images_conversions;
}

export interface Product_product {
  __typename: "Product";
  id: string;
  /**
   *  ERP-ben használt id, az olyan termékeknél null, amik nincsenek meg az ERP-ben, de a rendelésekkel áthoztuk 
   */
  ext_id: number | null;
  /**
   * Régi webshop termék id
   */
  previous_id: string | null;
  name: string;
  /**
   * Termék státusza/elérhetősége
   */
  status: ProductStatus;
  /**
   * Új url
   */
  url_key: string | null;
  /**
   * Régi url
   */
  smarturl: string | null;
  categories: Product_product_categories[] | null;
  default_category_id: number | null;
  price: number;
  /**
   * Az egységár egysége
   */
  price_unit: string | null;
  /**
   * Az egységár szorzója
   */
  price_per_unit: number | null;
  /**
   * Egységár
   */
  unit_price: number | null;
  /**
   * Akciós egységár
   */
  special_unit_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes ár 
   */
  personal_discount_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes egységár 
   */
  personal_discount_unit_price: number | null;
  /**
   * ÁFA
   */
  vat: number;
  /**
   * Akciós ár, bruttó
   */
  special_price: number | null;
  /**
   * Az akciós ár ettől a dátumtól érvényes
   */
  special_from_date: any | null;
  /**
   * Az akciós ár eeddig a dátumig érvényes
   */
  special_to_date: any | null;
  /**
   * Ettől a dátumtól "új" a termék
   */
  news_from_date: any | null;
  /**
   * Eddig a dátumig "új" a termék
   */
  news_to_date: any | null;
  /**
   * A termékre leadott szavazatok aggregálva
   */
  vote_calculated: Product_product_vote_calculated | null;
  /**
   * Leírás
   */
  description: string | null;
  /**
   * Összetevők leírása
   */
  components: string | null;
  /**
   * Tápanyaginformációk
   */
  nutrition_data: string | null;
  /**
   * Prefixboxtól kapott terméknépszerűség szám
   */
  prefixbox_score: number | null;
  /**
   * Vonalkódok
   */
  barcodes: string[] | null;
  /**
   * Alternatív mennyiség neve
   */
  alternative_quantity_name: ProductAlternativeQuantityName | null;
  /**
   * Alternatív mennyiség legkisebb választható egsége
   */
  alternative_quantity_minimum: number | null;
  /**
   * Alternatív mennyiség léptetési egysége
   */
  alternative_quantity_scale: number | null;
  /**
   * Eredeti/alternatív egység átváltási arány
   */
  alternative_quantity_exchange_rate: number | null;
  /**
   * Alapértelmezett mennyiség neve
   */
  default_quantity_name: ProductDefaultQuantityName | null;
  /**
   * Alapértelmezett mennyiség legkisebb választható egysége
   */
  default_quantity_minimum: number | null;
  /**
   * Alapértelmezett mennyiség léptetési egysége
   */
  default_quantity_scale: number | null;
  /**
   * Nem egész mennyiség is kosárba rakható-e a termékből (alapértelmezett mennyiségre vonatkozik)
   */
  is_qty_decimal: boolean;
  /**
   * Ajándékkártyával rendelhető
   */
  gift_message_available: boolean;
  /**
   * Csomagfutárral (MPL) szállítható
   */
  is_mpl: boolean;
  meta_title: string | null;
  meta_description: string | null;
  meta_keywords: string | null;
  /**
   * Minimum szavatosság: x nap
   */
  min_expiry_days: number | null;
  /**
   * A termék tényleges tömege
   */
  package_official_g: number | null;
  /**
   * A termék tényleges űrtartalma
   */
  package_official_ml: number | null;
  /**
   * Szeletelve rendelhető
   */
  sliceable: boolean | null;
  /**
   * Tömeg grammban
   */
  weight: number;
  /**
   *  A termékhez rendelt attribútumok és értékeik
   */
  attributes: Product_product_attributes[] | null;
  /**
   * Termék képek
   */
  images: Product_product_images[] | null;
  is_subscribed: boolean;
  created_at: any;
  updated_at: any | null;
}

export interface Product {
  product: Product_product | null;
}

export interface ProductVariables {
  getBy: getProductBy;
  value: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ProductAttribute
// ====================================================

export interface ProductAttribute_productAttribute_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
  position: number | null;
  is_active: boolean;
  is_default: boolean;
}

export interface ProductAttribute_productAttribute {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  /**
   *  Az attribútumra lehet-e szűrni a termékeket
   */
  filterable: boolean | null;
  is_active: boolean | null;
  /**
   *  Az attribútum típusa
   */
  type: ProductAttributeType;
  options: ProductAttribute_productAttribute_options[] | null;
}

export interface ProductAttribute {
  productAttribute: ProductAttribute_productAttribute | null;
}

export interface ProductAttributeVariables {
  code?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ProductAutocomplete
// ====================================================

export interface ProductAutocomplete_adminProducts_data {
  __typename: "AdminProduct";
  /**
   *  ERP-ben használt id 
   */
  ext_id: number | null;
  id: string;
  name: string;
}

export interface ProductAutocomplete_adminProducts {
  __typename: "AdminProductPaginator";
  data: ProductAutocomplete_adminProducts_data[];
}

export interface ProductAutocomplete {
  adminProducts: ProductAutocomplete_adminProducts | null;
}

export interface ProductAutocompleteVariables {
  filters?: AdminProductFilters | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ProductCategory
// ====================================================

export interface ProductCategory_adminProductCategoryById_children_children {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  product_count: number;
}

export interface ProductCategory_adminProductCategoryById_children {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  children: ProductCategory_adminProductCategoryById_children_children[] | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  is_homepage_prohibited: boolean;
  product_count: number;
}

export interface ProductCategory_adminProductCategoryById {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  children: ProductCategory_adminProductCategoryById_children[] | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  promotion_place: PromotionPlace | null;
  is_homepage_prohibited: boolean;
  product_count: number;
}

export interface ProductCategory {
  adminProductCategoryById: ProductCategory_adminProductCategoryById | null;
}

export interface ProductCategoryVariables {
  id: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: productImagesById
// ====================================================

export interface productImagesById_adminProducts_data_images_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface productImagesById_adminProducts_data_images {
  __typename: "ProductImage";
  id: string;
  url: string;
  mime_type: string;
  size: number;
  is_default: boolean;
  conversions: productImagesById_adminProducts_data_images_conversions;
}

export interface productImagesById_adminProducts_data {
  __typename: "AdminProduct";
  id: string;
  /**
   *  ERP-ben használt id 
   */
  ext_id: number | null;
  /**
   * Termék képek
   */
  images: productImagesById_adminProducts_data_images[] | null;
}

export interface productImagesById_adminProducts {
  __typename: "AdminProductPaginator";
  data: productImagesById_adminProducts_data[];
}

export interface productImagesById {
  adminProducts: productImagesById_adminProducts | null;
}

export interface productImagesByIdVariables {
  ext_id?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PromotionCategory
// ====================================================

export interface PromotionCategory_adminProductCategoryById_products_data {
  __typename: "Product";
  id: string;
  name: string;
}

export interface PromotionCategory_adminProductCategoryById_products {
  __typename: "ProductPaginator";
  data: PromotionCategory_adminProductCategoryById_products_data[];
}

export interface PromotionCategory_adminProductCategoryById {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  promotion_place: PromotionPlace | null;
  is_homepage_prohibited: boolean;
  products: PromotionCategory_adminProductCategoryById_products | null;
}

export interface PromotionCategory {
  adminProductCategoryById: PromotionCategory_adminProductCategoryById | null;
}

export interface PromotionCategoryVariables {
  id: number;
  sortBy: AdminProductOrder;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: user
// ====================================================

export interface user_listUsers_data_default_billing_address {
  __typename: "UserBillingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  vat_number: string | null;
  is_company: boolean;
  bank_transfer_enabled: boolean;
}

export interface user_listUsers_data_default_shipping_address {
  __typename: "UserShippingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  note: string | null;
  telephone: string | null;
}

export interface user_listUsers_data_shipping_addresses {
  __typename: "UserShippingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  note: string | null;
  telephone: string | null;
}

export interface user_listUsers_data_billing_addresses {
  __typename: "UserBillingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  vat_number: string | null;
  is_company: boolean;
  bank_transfer_enabled: boolean;
}

export interface user_listUsers_data_saved_credit_cards {
  __typename: "UserSavedCreditCard";
  id: string;
  card_title: string | null;
  card_type: string | null;
  card_pan: string | null;
  card_exp: any | null;
  is_default: boolean;
}

export interface user_listUsers_data_product_discounts {
  __typename: "UserProductDiscount";
  id: string;
  discount: number;
  user_id: string;
  is_active: boolean;
  active_from: any;
  active_to: any;
  created_at: any;
  updated_at: any;
}

export interface user_listUsers_data_shipping_discounts {
  __typename: "UserShippingDiscount";
  id: string;
  discount: number;
  user_id: string;
  is_active: boolean;
  active_from: any;
  active_to: any;
  created_at: any;
  updated_at: any;
}

export interface user_listUsers_data {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  default_billing_address: user_listUsers_data_default_billing_address | null;
  default_shipping_address: user_listUsers_data_default_shipping_address | null;
  shipping_addresses: user_listUsers_data_shipping_addresses[] | null;
  billing_addresses: user_listUsers_data_billing_addresses[] | null;
  saved_credit_cards: user_listUsers_data_saved_credit_cards[] | null;
  product_discounts: user_listUsers_data_product_discounts[] | null;
  shipping_discounts: user_listUsers_data_shipping_discounts[] | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
}

export interface user_listUsers {
  __typename: "UserPaginator";
  data: user_listUsers_data[];
}

export interface user {
  listUsers: user_listUsers | null;
}

export interface userVariables {
  filters?: UserFilters | null;
  sortBy?: UserSort | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: userList
// ====================================================

export interface userList_listUsers_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface userList_listUsers_data_shipping_addresses {
  __typename: "UserShippingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  note: string | null;
  telephone: string | null;
  is_goodid: boolean;
}

export interface userList_listUsers_data_orders_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface userList_listUsers_data_orders {
  __typename: "OrderPaginator";
  paginatorInfo: userList_listUsers_data_orders_paginatorInfo;
}

export interface userList_listUsers_data {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  telephone: string | null;
  ext_id: string;
  last_login: any | null;
  ip_address: string | null;
  shipping_addresses: userList_listUsers_data_shipping_addresses[] | null;
  orders: userList_listUsers_data_orders | null;
}

export interface userList_listUsers {
  __typename: "UserPaginator";
  paginatorInfo: userList_listUsers_paginatorInfo;
  data: userList_listUsers_data[];
}

export interface userList {
  listUsers: userList_listUsers | null;
}

export interface userListVariables {
  filters?: UserFilters | null;
  sortBy?: UserSort | null;
  count: number;
  page?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminBannerAllData
// ====================================================

export interface AdminBannerAllData_banner_places {
  __typename: "BannerPlace";
  id: string;
  name: string;
  type_id: BannerPlaceType;
}

export interface AdminBannerAllData {
  __typename: "AdminBanner";
  id: string;
  name: string;
  active_from: any | null;
  active_to: any | null;
  url: string;
  url_target: BannerUrlTarget;
  image_url_desktop: string;
  image_url_mobile: string;
  is_active: boolean;
  priority: number;
  created_at: any;
  updated_at: any | null;
  banner_places: AdminBannerAllData_banner_places[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminCmsAllData
// ====================================================

export interface AdminCmsAllData {
  __typename: "AdminCmsContent";
  id: string;
  title: string;
  content: string | null;
  url_key: string;
  is_active: boolean;
  active_from: any | null;
  active_to: any | null;
  meta_title: string | null;
  meta_keywords: string | null;
  meta_description: string | null;
  created_at: any;
  updated_at: any | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminCmsListItem
// ====================================================

export interface AdminCmsListItem {
  __typename: "AdminCmsContent";
  id: string;
  title: string;
  url_key: string;
  is_active: boolean;
  active_from: any | null;
  active_to: any | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminDonationItem
// ====================================================

export interface AdminDonationItem {
  __typename: "AdminDonation";
  id: string;
  name: string;
  active_from: any;
  active_to: any;
  cms_url: string;
  donation_total: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminProductAllData
// ====================================================

export interface AdminProductAllData_categories {
  __typename: "ProductCategory";
  id: string;
  name: string;
}

export interface AdminProductAllData_vote_calculated {
  __typename: "ProductVoteCalculated";
  /**
   * A termékre leadott szavazatok átlaga
   */
  vote_avg: number;
  vote_count_one: number;
  vote_count_two: number;
  vote_count_three: number;
  vote_count_four: number;
  vote_count_five: number;
}

export interface AdminProductAllData_empties {
  __typename: "Product";
  id: string;
  name: string;
}

export interface AdminProductAllData_attributes_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
}

export interface AdminProductAllData_attributes {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  options: AdminProductAllData_attributes_options[] | null;
}

export interface AdminProductAllData_images_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface AdminProductAllData_images {
  __typename: "ProductImage";
  id: string;
  url: string;
  conversions: AdminProductAllData_images_conversions;
}

export interface AdminProductAllData {
  __typename: "AdminProduct";
  id: string;
  /**
   *  ERP-ben használt id 
   */
  ext_id: number | null;
  /**
   * Régi webshop termék id
   */
  previous_id: string | null;
  name: string;
  /**
   * Termék státusza/elérhetősége
   */
  status: ProductStatus;
  /**
   * Új url
   */
  url_key: string | null;
  /**
   * Régi url
   */
  smarturl: string | null;
  categories: AdminProductAllData_categories[] | null;
  default_category_id: number | null;
  price: number;
  /**
   * Az egységár egysége
   */
  price_unit: string | null;
  /**
   * Az egységár szorzója
   */
  price_per_unit: number | null;
  /**
   * Egységár
   */
  unit_price: number | null;
  /**
   * Akciós egységár
   */
  special_unit_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes ár 
   */
  personal_discount_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes egységár 
   */
  personal_discount_unit_price: number | null;
  /**
   * ÁFA
   */
  vat: number;
  /**
   * Akciós ár, bruttó
   */
  special_price: number | null;
  /**
   * Az akciós ár ettől a dátumtól érvényes
   */
  special_from_date: any | null;
  /**
   * Az akciós ár eeddig a dátumig érvényes
   */
  special_to_date: any | null;
  /**
   * Ettől a dátumtól "új" a termék
   */
  news_from_date: any | null;
  /**
   * Eddig a dátumig "új" a termék
   */
  news_to_date: any | null;
  /**
   * Leírás
   */
  description: string | null;
  /**
   * Összetevők leírása
   */
  components: string | null;
  /**
   * Tápanyaginformációk
   */
  nutrition_data: string | null;
  /**
   * A termékre leadott szavazatok aggregálva
   */
  vote_calculated: AdminProductAllData_vote_calculated | null;
  /**
   * Prefixboxtól kapott terméknépszerűség szám
   */
  prefixbox_score: number | null;
  /**
   * Vonalkódok
   */
  barcodes: string[] | null;
  /**
   * Alternatív mennyiség neve
   */
  alternative_quantity_name: ProductAlternativeQuantityName | null;
  /**
   * Alternatív mennyiség legkisebb választható egsége
   */
  alternative_quantity_minimum: number | null;
  /**
   * Alternatív mennyiség léptetési egysége
   */
  alternative_quantity_scale: number | null;
  /**
   * Eredeti/alternatív egység átváltási arány
   */
  alternative_quantity_exchange_rate: number | null;
  /**
   * Alapértelmezett mennyiség neve
   */
  default_quantity_name: ProductDefaultQuantityName | null;
  /**
   * Alapértelmezett mennyiség legkisebb választható egysége
   */
  default_quantity_minimum: number | null;
  /**
   * Alapértelmezett mennyiség léptetési egysége
   */
  default_quantity_scale: number | null;
  /**
   * Nem egész mennyiség is kosárba rakható-e a termékből (alapértelmezett mennyiségre vonatkozik)
   */
  is_qty_decimal: boolean;
  /**
   * Ajándékkártyával rendelhető
   */
  gift_message_available: boolean;
  /**
   * Csomagfutárral (MPL) szállítható
   */
  is_mpl: boolean;
  meta_title: string | null;
  meta_description: string | null;
  meta_keywords: string | null;
  /**
   * Minimum szavatosság: x nap
   */
  min_expiry_days: number | null;
  /**
   * A termék tényleges tömege
   */
  package_official_g: number | null;
  /**
   * A termék tényleges űrtartalma
   */
  package_official_ml: number | null;
  /**
   * Szeletelve rendelhető
   */
  sliceable: boolean | null;
  /**
   * Tömeg grammban
   */
  weight: number;
  /**
   * Göngyöleg
   */
  empties: AdminProductAllData_empties | null;
  /**
   *  A termékhez rendelt attribútumok és értékeik
   */
  attributes: AdminProductAllData_attributes[] | null;
  /**
   * Termék képek
   */
  images: AdminProductAllData_images[] | null;
  created_at: any;
  updated_at: any | null;
  /**
   * Internetes ár
   */
  webshop_only_price: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminProductCategoryAllDataFragment
// ====================================================

export interface AdminProductCategoryAllDataFragment_children_children {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  product_count: number;
}

export interface AdminProductCategoryAllDataFragment_children {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  children: AdminProductCategoryAllDataFragment_children_children[] | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  is_homepage_prohibited: boolean;
  product_count: number;
}

export interface AdminProductCategoryAllDataFragment {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  children: AdminProductCategoryAllDataFragment_children[] | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  promotion_place: PromotionPlace | null;
  is_homepage_prohibited: boolean;
  product_count: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminProductListAdFragment
// ====================================================

export interface AdminProductListAdFragment_urls {
  __typename: "ProductListAdUrl";
  url: string;
}

export interface AdminProductListAdFragment {
  __typename: "AdminProductListAd";
  id: string;
  name: string;
  type: ProductListAdType;
  image_url_desktop: string | null;
  image_url_mobile: string | null;
  urls: AdminProductListAdFragment_urls[] | null;
  is_active: boolean;
  active_from: any | null;
  active_to: any | null;
  created_at: any;
  updated_at: any | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminProductListItem
// ====================================================

export interface AdminProductListItem_categories {
  __typename: "ProductCategory";
  id: string;
  name: string;
}

export interface AdminProductListItem {
  __typename: "AdminProduct";
  id: string;
  /**
   *  ERP-ben használt id 
   */
  ext_id: number | null;
  name: string;
  /**
   * Termék státusza/elérhetősége
   */
  status: ProductStatus;
  price: number;
  /**
   * Akciós ár, bruttó
   */
  special_price: number | null;
  /**
   * Az akciós ár ettől a dátumtól érvényes
   */
  special_from_date: any | null;
  /**
   * Az akciós ár eeddig a dátumig érvényes
   */
  special_to_date: any | null;
  /**
   * Ettől a dátumtól "új" a termék
   */
  news_from_date: any | null;
  /**
   * Eddig a dátumig "új" a termék
   */
  news_to_date: any | null;
  categories: AdminProductListItem_categories[] | null;
  /**
   * Csomagfutárral (MPL) szállítható
   */
  is_mpl: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminPromotionCategoryAllData
// ====================================================

export interface AdminPromotionCategoryAllData {
  __typename: "AdminProductCategory";
  id: string;
  name: string;
  parent_id: number | null;
  url_key: string;
  content: string | null;
  is_enable: boolean;
  sort: number | null;
  date_from: any | null;
  date_to: any | null;
  show_in_menu: boolean | null;
  keywords: string | null;
  description: string | null;
  is_promotion: boolean;
  promotion_place: PromotionPlace | null;
  is_homepage_prohibited: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AuthenticationResultFragment
// ====================================================

export interface AuthenticationResultFragment_user {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

export interface AuthenticationResultFragment {
  __typename: "AuthenticationResult";
  token: string | null;
  user: AuthenticationResultFragment_user | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BannerListItemFragment
// ====================================================

export interface BannerListItemFragment_banner_places {
  __typename: "BannerPlace";
  id: string;
  name: string;
}

export interface BannerListItemFragment {
  __typename: "AdminBanner";
  id: string;
  name: string;
  active_from: any | null;
  active_to: any | null;
  is_active: boolean;
  banner_places: BannerListItemFragment_banner_places[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CouponCodeAllData
// ====================================================

export interface CouponCodeAllData {
  __typename: "CouponCode";
  code: string;
  /**
   *  Ennyiszer használható fel a kuponkód 
   */
  usage_count: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CouponListItem
// ====================================================

export interface CouponListItem_codes_data {
  __typename: "CouponCode";
  /**
   *  Ennyiszer használható fel a kuponkód 
   */
  usage_count: number;
}

export interface CouponListItem_codes {
  __typename: "CouponCodePaginator";
  data: CouponListItem_codes_data[];
}

export interface CouponListItem {
  __typename: "Coupon";
  id: string;
  name: string;
  active_from: any;
  active_to: any;
  type: CouponType;
  /**
   *  Mire érvényes: termék, szállítás 
   */
  applied_to: CouponAppliedTo;
  /**
   *  + ingyen szállítás? 
   */
  is_free_shipping: boolean;
  is_active: boolean;
  /**
   *  Ennyiszer haszálhatóak fel a kuponhoz tartozó kódok 
   */
  usage_count: number;
  /**
   *  Más kedvezménnyel összevonható? 
   */
  is_combinable: boolean;
  created_at: any;
  updated_at: any | null;
  /**
   *  Generált kuponkódok száma 
   */
  generated_codes_count: number;
  /**
   *  Felhasznált kuponkódok száma 
   */
  used_codes_count: number;
  codes: CouponListItem_codes | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OrderAllData
// ====================================================

export interface OrderAllData_timetable_time_slot_sector {
  __typename: "TimetableSector";
  name: string;
}

export interface OrderAllData_timetable_time_slot_timeRange {
  __typename: "TimetableTimeRange";
  time_from: string;
  time_to: string;
}

export interface OrderAllData_timetable_time_slot {
  __typename: "TimetableTimeSlot";
  id: string;
  sector: OrderAllData_timetable_time_slot_sector;
  range_date: any;
  timeRange: OrderAllData_timetable_time_slot_timeRange;
}

export interface OrderAllData_post_point {
  __typename: "PostPoint";
  id: string;
  name: string;
  ext_id: string;
  postcode: number;
  city: string;
  street_name: string | null;
  street_type: string | null;
  house_number: string | null;
  latitude: number;
  longitude: number;
  service_point_type: string | null;
  working_hours: any | null;
}

export interface OrderAllData_shipping_method {
  __typename: "ShippingMethod";
  id: string;
  name: string;
}

export interface OrderAllData_payment_method {
  __typename: "PaymentMethod";
  id: string;
  name: string;
}

export interface OrderAllData_user {
  __typename: "User";
  id: string;
  name: string;
}

export interface OrderAllData_order_products_product {
  __typename: "Product";
  id: string;
  name: string;
  /**
   * Tömeg grammban
   */
  weight: number;
}

export interface OrderAllData_order_products {
  __typename: "OrderProduct";
  price: number;
  special_price: number | null;
  default_quantity_name: string;
  default_quantity_piece: number;
  alternative_quantity_name: string | null;
  alternative_quantity_piece: number | null;
  product: OrderAllData_order_products_product;
  sliced: boolean | null;
  additional_information: string | null;
}

export interface OrderAllData_status {
  __typename: "OrderStatus";
  title: string;
  code: OrderStatusCode;
}

export interface OrderAllData_coupon_data {
  __typename: "OrderCouponData";
  name: string;
  code: string;
  product_discount: number | null;
  shipping_discount: number | null;
}

export interface OrderAllData_linked_orders {
  __typename: "Order";
  id: string;
}

export interface OrderAllData_parent_order {
  __typename: "Order";
  id: string;
}

export interface OrderAllData_contact_data {
  __typename: "ContactPersonData";
  contact_name: string;
  contact_email: string;
  contact_telephone: string;
}

export interface OrderAllData_donation_data {
  __typename: "OrderDonation";
  /**
   *  Az adakozás típusa (kerekített vagy egyedi összeg) 
   */
  type: OrderDonationType;
  /**
   *  Az adomány összege 
   */
  amount: number;
}

export interface OrderAllData {
  __typename: "Order";
  id: string;
  total_amount: number;
  total_sum: number;
  shipping_cost: number;
  timetable_time_slot: OrderAllData_timetable_time_slot | null;
  post_point: OrderAllData_post_point | null;
  shipping_method: OrderAllData_shipping_method;
  payment_method: OrderAllData_payment_method;
  shipping_name: string;
  shipping_postcode: string;
  shipping_city: string;
  shipping_street: string;
  shipping_house_number: string;
  shipping_telephone: string;
  shipping_note: string | null;
  billing_name: string;
  billing_postcode: string;
  billing_city: string;
  billing_street: string;
  billing_house_number: string;
  vat_number: string | null;
  is_company: boolean | null;
  user: OrderAllData_user | null;
  comment: string | null;
  lyoness_card_number: string | null;
  order_products: OrderAllData_order_products[];
  status: OrderAllData_status;
  coupon_data: OrderAllData_coupon_data | null;
  linked_orders: (OrderAllData_linked_orders | null)[] | null;
  parent_order: OrderAllData_parent_order | null;
  created_at: any;
  contact_data: OrderAllData_contact_data | null;
  erp_comment: string | null;
  admin_id: string | null;
  donation_data: OrderAllData_donation_data | null;
  payment_method_cost: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OrderListItem
// ====================================================

export interface OrderListItem_user_orders_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface OrderListItem_user_orders {
  __typename: "OrderPaginator";
  paginatorInfo: OrderListItem_user_orders_paginatorInfo;
}

export interface OrderListItem_user {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  ext_id: string;
  orders: OrderListItem_user_orders | null;
}

export interface OrderListItem_contact_data {
  __typename: "ContactPersonData";
  contact_name: string;
  contact_email: string;
  contact_telephone: string;
}

export interface OrderListItem_status {
  __typename: "OrderStatus";
  title: string;
  code: OrderStatusCode;
}

export interface OrderListItem_shipping_method {
  __typename: "ShippingMethod";
  id: string;
  name: string;
}

export interface OrderListItem {
  __typename: "Order";
  id: string;
  created_at: any;
  user: OrderListItem_user | null;
  contact_data: OrderListItem_contact_data | null;
  total_amount: number;
  total_sum: number;
  status: OrderListItem_status;
  shipping_method: OrderListItem_shipping_method;
  is_admin_checked: boolean | null;
  /**
   *  A kapcsolt rendelés (parent_order) id-ja 
   */
  linked_order_id: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OrderUpdateLogOriginal
// ====================================================

export interface OrderUpdateLogOriginal_timetable_time_slot_sector {
  __typename: "TimetableSector";
  name: string;
}

export interface OrderUpdateLogOriginal_timetable_time_slot_timeRange {
  __typename: "TimetableTimeRange";
  time_from: string;
  time_to: string;
}

export interface OrderUpdateLogOriginal_timetable_time_slot {
  __typename: "TimetableTimeSlot";
  sector: OrderUpdateLogOriginal_timetable_time_slot_sector;
  range_date: any;
  timeRange: OrderUpdateLogOriginal_timetable_time_slot_timeRange;
}

export interface OrderUpdateLogOriginal_post_point {
  __typename: "PostPoint";
  id: string;
}

export interface OrderUpdateLogOriginal_shipping_method {
  __typename: "ShippingMethod";
  id: string;
}

export interface OrderUpdateLogOriginal_payment_method {
  __typename: "PaymentMethod";
  id: string;
}

export interface OrderUpdateLogOriginal_linked_order {
  __typename: "Order";
  id: string;
}

export interface OrderUpdateLogOriginal_status {
  __typename: "OrderStatus";
  title: string;
}

export interface OrderUpdateLogOriginal {
  __typename: "OrderUpdateLogData";
  synchronized: boolean | null;
  total_amount: number | null;
  shipping_cost: number | null;
  timetable_time_slot: OrderUpdateLogOriginal_timetable_time_slot | null;
  post_point: OrderUpdateLogOriginal_post_point | null;
  shipping_method: OrderUpdateLogOriginal_shipping_method | null;
  payment_method: OrderUpdateLogOriginal_payment_method | null;
  linked_order: OrderUpdateLogOriginal_linked_order | null;
  comment: string | null;
  status: OrderUpdateLogOriginal_status | null;
  is_admin_checked: boolean | null;
  admin_id: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PaginatorInfoFragment
// ====================================================

export interface PaginatorInfoFragment {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PaymentMethodAllFragment
// ====================================================

export interface PaymentMethodAllFragment {
  __typename: "PaymentMethod";
  id: string;
  name: string;
  is_active: boolean;
  code: string;
  sort: number;
  short_description: string | null;
  short_description_mpl_type: string | null;
  cost: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PaymentMethodFragment
// ====================================================

export interface PaymentMethodFragment {
  __typename: "PaymentMethod";
  id: string;
  name: string;
  is_active: boolean;
  sort: number;
  short_description: string | null;
  short_description_mpl_type: string | null;
  cost: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductAllData
// ====================================================

export interface ProductAllData_categories {
  __typename: "ProductCategory";
  id: string;
  name: string;
}

export interface ProductAllData_vote_calculated {
  __typename: "ProductVoteCalculated";
  /**
   * A termékre leadott szavazatok átlaga
   */
  vote_avg: number;
  vote_count_one: number;
  vote_count_two: number;
  vote_count_three: number;
  vote_count_four: number;
  vote_count_five: number;
}

export interface ProductAllData_attributes_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
}

export interface ProductAllData_attributes {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  options: ProductAllData_attributes_options[] | null;
}

export interface ProductAllData_images_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface ProductAllData_images {
  __typename: "ProductImage";
  id: string;
  is_default: boolean;
  url: string;
  conversions: ProductAllData_images_conversions;
}

export interface ProductAllData {
  __typename: "Product";
  id: string;
  /**
   *  ERP-ben használt id, az olyan termékeknél null, amik nincsenek meg az ERP-ben, de a rendelésekkel áthoztuk 
   */
  ext_id: number | null;
  /**
   * Régi webshop termék id
   */
  previous_id: string | null;
  name: string;
  /**
   * Termék státusza/elérhetősége
   */
  status: ProductStatus;
  /**
   * Új url
   */
  url_key: string | null;
  /**
   * Régi url
   */
  smarturl: string | null;
  categories: ProductAllData_categories[] | null;
  default_category_id: number | null;
  price: number;
  /**
   * Az egységár egysége
   */
  price_unit: string | null;
  /**
   * Az egységár szorzója
   */
  price_per_unit: number | null;
  /**
   * Egységár
   */
  unit_price: number | null;
  /**
   * Akciós egységár
   */
  special_unit_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes ár 
   */
  personal_discount_price: number | null;
  /**
   *  Felhasználói egyedi kedvezményes egységár 
   */
  personal_discount_unit_price: number | null;
  /**
   * ÁFA
   */
  vat: number;
  /**
   * Akciós ár, bruttó
   */
  special_price: number | null;
  /**
   * Az akciós ár ettől a dátumtól érvényes
   */
  special_from_date: any | null;
  /**
   * Az akciós ár eeddig a dátumig érvényes
   */
  special_to_date: any | null;
  /**
   * Ettől a dátumtól "új" a termék
   */
  news_from_date: any | null;
  /**
   * Eddig a dátumig "új" a termék
   */
  news_to_date: any | null;
  /**
   * A termékre leadott szavazatok aggregálva
   */
  vote_calculated: ProductAllData_vote_calculated | null;
  /**
   * Leírás
   */
  description: string | null;
  /**
   * Összetevők leírása
   */
  components: string | null;
  /**
   * Tápanyaginformációk
   */
  nutrition_data: string | null;
  /**
   * Prefixboxtól kapott terméknépszerűség szám
   */
  prefixbox_score: number | null;
  /**
   * Vonalkódok
   */
  barcodes: string[] | null;
  /**
   * Alternatív mennyiség neve
   */
  alternative_quantity_name: ProductAlternativeQuantityName | null;
  /**
   * Alternatív mennyiség legkisebb választható egsége
   */
  alternative_quantity_minimum: number | null;
  /**
   * Alternatív mennyiség léptetési egysége
   */
  alternative_quantity_scale: number | null;
  /**
   * Eredeti/alternatív egység átváltási arány
   */
  alternative_quantity_exchange_rate: number | null;
  /**
   * Alapértelmezett mennyiség neve
   */
  default_quantity_name: ProductDefaultQuantityName | null;
  /**
   * Alapértelmezett mennyiség legkisebb választható egysége
   */
  default_quantity_minimum: number | null;
  /**
   * Alapértelmezett mennyiség léptetési egysége
   */
  default_quantity_scale: number | null;
  /**
   * Nem egész mennyiség is kosárba rakható-e a termékből (alapértelmezett mennyiségre vonatkozik)
   */
  is_qty_decimal: boolean;
  /**
   * Ajándékkártyával rendelhető
   */
  gift_message_available: boolean;
  /**
   * Csomagfutárral (MPL) szállítható
   */
  is_mpl: boolean;
  meta_title: string | null;
  meta_description: string | null;
  meta_keywords: string | null;
  /**
   * Minimum szavatosság: x nap
   */
  min_expiry_days: number | null;
  /**
   * A termék tényleges tömege
   */
  package_official_g: number | null;
  /**
   * A termék tényleges űrtartalma
   */
  package_official_ml: number | null;
  /**
   * Szeletelve rendelhető
   */
  sliceable: boolean | null;
  /**
   * Tömeg grammban
   */
  weight: number;
  /**
   *  A termékhez rendelt attribútumok és értékeik
   */
  attributes: ProductAllData_attributes[] | null;
  /**
   * Termék képek
   */
  images: ProductAllData_images[] | null;
  is_subscribed: boolean;
  created_at: any;
  updated_at: any | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductAttributeAllData
// ====================================================

export interface ProductAttributeAllData_options {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
  position: number | null;
  is_active: boolean;
  is_default: boolean;
}

export interface ProductAttributeAllData {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  /**
   *  Az attribútumra lehet-e szűrni a termékeket
   */
  filterable: boolean | null;
  is_active: boolean | null;
  /**
   *  Az attribútum típusa
   */
  type: ProductAttributeType;
  options: ProductAttributeAllData_options[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductAttributeListItem
// ====================================================

export interface ProductAttributeListItem {
  __typename: "ProductAttribute";
  id: string;
  name: string;
  code: string;
  /**
   *  Az attribútumra lehet-e szűrni a termékeket
   */
  filterable: boolean | null;
  is_active: boolean | null;
  /**
   *  Az attribútum típusa
   */
  type: ProductAttributeType;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductAttributeOptionAllData
// ====================================================

export interface ProductAttributeOptionAllData {
  __typename: "ProductAttributeOption";
  id: string;
  label: string;
  position: number | null;
  is_active: boolean;
  is_default: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductImageAllData
// ====================================================

export interface ProductImageAllData_conversions {
  __typename: "ProductImageConversions";
  thumbnail: string | null;
  list: string | null;
  full: string | null;
}

export interface ProductImageAllData {
  __typename: "ProductImage";
  id: string;
  url: string;
  mime_type: string;
  size: number;
  is_default: boolean;
  conversions: ProductImageAllData_conversions;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ShippingMethodAllFragment
// ====================================================

export interface ShippingMethodAllFragment_price_ranges {
  __typename: "ShippingMethodPriceRange";
  from: number;
  price: number;
}

export interface ShippingMethodAllFragment {
  __typename: "ShippingMethod";
  id: string;
  code: string;
  name: string;
  is_active: boolean;
  sort: number;
  price_ranges: ShippingMethodAllFragment_price_ranges[] | null;
  discount_price: number | null;
  max_weight: number | null;
  description: string | null;
  short_description: string | null;
  delivery_time: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TimetableTimeSlotAllData
// ====================================================

export interface TimetableTimeSlotAllData_sector {
  __typename: "TimetableSector";
  id: string;
  name: string;
}

export interface TimetableTimeSlotAllData_timeRange {
  __typename: "TimetableTimeRange";
  id: string;
  time_from: string;
  time_to: string;
}

export interface TimetableTimeSlotAllData_orders_status {
  __typename: "OrderStatus";
  code: OrderStatusCode;
}

export interface TimetableTimeSlotAllData_orders_parent_order {
  __typename: "Order";
  id: string;
}

export interface TimetableTimeSlotAllData_orders {
  __typename: "Order";
  id: string;
  shipping_postcode: string;
  status: TimetableTimeSlotAllData_orders_status;
  parent_order: TimetableTimeSlotAllData_orders_parent_order | null;
}

export interface TimetableTimeSlotAllData {
  __typename: "TimetableTimeSlot";
  id: string;
  sector: TimetableTimeSlotAllData_sector;
  order_limit: number;
  weight_limit: number;
  price: number;
  range_date: any;
  timeRange: TimetableTimeSlotAllData_timeRange;
  visible_until: any;
  status: TimetableTimeSlotStatusType;
  reserved_order_count: number;
  reserved_weight_count: number;
  orders: TimetableTimeSlotAllData_orders[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UrlAliasAllData
// ====================================================

export interface UrlAliasAllData {
  __typename: "UrlAlias";
  id: string;
  source_url: string;
  target_url: string;
  created_at: any;
  updated_at: any | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserAllDataFragment
// ====================================================

export interface UserAllDataFragment {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
  granted_permissions: (Permission | null)[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserBillingAddressFragment
// ====================================================

export interface UserBillingAddressFragment {
  __typename: "UserBillingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  vat_number: string | null;
  is_company: boolean;
  bank_transfer_enabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserDetailsFragment
// ====================================================

export interface UserDetailsFragment_default_billing_address {
  __typename: "UserBillingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  vat_number: string | null;
  is_company: boolean;
  bank_transfer_enabled: boolean;
}

export interface UserDetailsFragment_default_shipping_address {
  __typename: "UserShippingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  note: string | null;
  telephone: string | null;
}

export interface UserDetailsFragment_shipping_addresses {
  __typename: "UserShippingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  note: string | null;
  telephone: string | null;
}

export interface UserDetailsFragment_billing_addresses {
  __typename: "UserBillingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  vat_number: string | null;
  is_company: boolean;
  bank_transfer_enabled: boolean;
}

export interface UserDetailsFragment_saved_credit_cards {
  __typename: "UserSavedCreditCard";
  id: string;
  card_title: string | null;
  card_type: string | null;
  card_pan: string | null;
  card_exp: any | null;
  is_default: boolean;
}

export interface UserDetailsFragment_product_discounts {
  __typename: "UserProductDiscount";
  id: string;
  discount: number;
  user_id: string;
  is_active: boolean;
  active_from: any;
  active_to: any;
  created_at: any;
  updated_at: any;
}

export interface UserDetailsFragment_shipping_discounts {
  __typename: "UserShippingDiscount";
  id: string;
  discount: number;
  user_id: string;
  is_active: boolean;
  active_from: any;
  active_to: any;
  created_at: any;
  updated_at: any;
}

export interface UserDetailsFragment {
  __typename: "User";
  id: string;
  ext_id: string;
  last_login: any | null;
  email: string;
  name: string;
  telephone: string | null;
  default_billing_address: UserDetailsFragment_default_billing_address | null;
  default_shipping_address: UserDetailsFragment_default_shipping_address | null;
  shipping_addresses: UserDetailsFragment_shipping_addresses[] | null;
  billing_addresses: UserDetailsFragment_billing_addresses[] | null;
  saved_credit_cards: UserDetailsFragment_saved_credit_cards[] | null;
  product_discounts: UserDetailsFragment_product_discounts[] | null;
  shipping_discounts: UserDetailsFragment_shipping_discounts[] | null;
  created_at: any;
  lyoness_card_number: string | null;
  is_admin: boolean;
  ip_address: string | null;
  orders_count: number;
  orders_value_sum: number;
  first_order_date: any | null;
  last_order_date: any | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserListItemFragment
// ====================================================

export interface UserListItemFragment_shipping_addresses {
  __typename: "UserShippingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  note: string | null;
  telephone: string | null;
  is_goodid: boolean;
}

export interface UserListItemFragment_orders_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface UserListItemFragment_orders {
  __typename: "OrderPaginator";
  paginatorInfo: UserListItemFragment_orders_paginatorInfo;
}

export interface UserListItemFragment {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  telephone: string | null;
  ext_id: string;
  last_login: any | null;
  ip_address: string | null;
  shipping_addresses: UserListItemFragment_shipping_addresses[] | null;
  orders: UserListItemFragment_orders | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserPaginator
// ====================================================

export interface UserPaginator_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total count of available items in the page.
   */
  count: number;
  /**
   * Current pagination page.
   */
  currentPage: number;
  /**
   * Index of first item in the current page.
   */
  firstItem: number | null;
  /**
   * If collection has more pages.
   */
  hasMorePages: boolean;
  /**
   * Index of last item in the current page.
   */
  lastItem: number | null;
  /**
   * Last page number of the collection.
   */
  lastPage: number;
  /**
   * Number of items per page in the collection.
   */
  perPage: number;
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface UserPaginator_data_shipping_addresses {
  __typename: "UserShippingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  note: string | null;
  telephone: string | null;
  is_goodid: boolean;
}

export interface UserPaginator_data_orders_paginatorInfo {
  __typename: "PaginatorInfo";
  /**
   * Total items available in the collection.
   */
  total: number;
}

export interface UserPaginator_data_orders {
  __typename: "OrderPaginator";
  paginatorInfo: UserPaginator_data_orders_paginatorInfo;
}

export interface UserPaginator_data {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  telephone: string | null;
  ext_id: string;
  last_login: any | null;
  ip_address: string | null;
  shipping_addresses: UserPaginator_data_shipping_addresses[] | null;
  orders: UserPaginator_data_orders | null;
}

export interface UserPaginator {
  __typename: "UserPaginator";
  paginatorInfo: UserPaginator_paginatorInfo;
  data: UserPaginator_data[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserProductDiscountFragment
// ====================================================

export interface UserProductDiscountFragment {
  __typename: "UserProductDiscount";
  id: string;
  user_id: string;
  is_active: boolean;
  active_from: any;
  active_to: any;
  created_at: any;
  updated_at: any;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserShippingAddressFragment
// ====================================================

export interface UserShippingAddressFragment {
  __typename: "UserShippingAddress";
  id: string;
  name: string;
  postcode: string;
  city: string;
  street: string;
  house_number: string;
  is_default: boolean;
  note: string | null;
  telephone: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserShippingDiscountFragment
// ====================================================

export interface UserShippingDiscountFragment {
  __typename: "UserShippingDiscount";
  id: string;
  user_id: string;
  is_active: boolean;
  active_from: any;
  active_to: any;
  created_at: any;
  updated_at: any;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AdminBannerOrderField {
  ACTIVE_FROM = "ACTIVE_FROM",
  ACTIVE_TO = "ACTIVE_TO",
  BANNER_PLACE_NAME = "BANNER_PLACE_NAME",
  CREATED_AT = "CREATED_AT",
  ID = "ID",
  IS_ACTIVE = "IS_ACTIVE",
  NAME = "NAME",
  UPDATED_AT = "UPDATED_AT",
  URL = "URL",
}

export enum AdminCmsContentField {
  ACTIVE_FROM = "ACTIVE_FROM",
  ACTIVE_TO = "ACTIVE_TO",
  CREATED_AT = "CREATED_AT",
  ID = "ID",
  TITLE = "TITLE",
  UPDATED_AT = "UPDATED_AT",
  URL_KEY = "URL_KEY",
}

export enum AdminCouponOrderField {
  ACTIVE_FROM = "ACTIVE_FROM",
  ACTIVE_TO = "ACTIVE_TO",
  CREATED_AT = "CREATED_AT",
  GENERATED_CODES_COUNT = "GENERATED_CODES_COUNT",
  ID = "ID",
  NAME = "NAME",
  UPDATED_AT = "UPDATED_AT",
}

export enum AdminDonationOrderField {
  ACTIVE_FROM = "ACTIVE_FROM",
  ACTIVE_TO = "ACTIVE_TO",
  CREATED_AT = "CREATED_AT",
  DONATION_TOTAL = "DONATION_TOTAL",
  FIRST_DONATION = "FIRST_DONATION",
  ID = "ID",
  LAST_DONATION = "LAST_DONATION",
  NAME = "NAME",
  UPDATED_AT = "UPDATED_AT",
}

export enum AdminNumericFields {
  ID = "ID",
  PRICE = "PRICE",
}

export enum AdminProductListAdField {
  ACTIVE_FROM = "ACTIVE_FROM",
  ACTIVE_TO = "ACTIVE_TO",
  CREATED_AT = "CREATED_AT",
  ID = "ID",
  NAME = "NAME",
  UPDATED_AT = "UPDATED_AT",
}

export enum AdminProductOrderField {
  EXT_ID = "EXT_ID",
  ID = "ID",
  NAME = "NAME",
  NEWS_TO = "NEWS_TO",
  PRICE = "PRICE",
  SORT = "SORT",
  SPECIAL_PRICE_TO = "SPECIAL_PRICE_TO",
  STATUS = "STATUS",
  UNIT_PRICE = "UNIT_PRICE",
}

export enum AuthenticationType {
  facebook = "facebook",
  goodid = "goodid",
  google = "google",
  okoslista = "okoslista",
  password = "password",
}

export enum BannerPlaceType {
  BANNER = "BANNER",
  SLIDER = "SLIDER",
}

export enum BannerUrlTarget {
  _blank = "_blank",
  _self = "_self",
}

export enum CouponAppliedTo {
  PRODUCT = "PRODUCT",
  SHIPPING = "SHIPPING",
}

export enum CouponCodeType {
  ALPHANUMERIC = "ALPHANUMERIC",
  LETTERS = "LETTERS",
  NUMBERS = "NUMBERS",
  SAFE_ALPHANUMERIC = "SAFE_ALPHANUMERIC",
}

export enum CouponType {
  PERCENT = "PERCENT",
  VALUE = "VALUE",
}

export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum OrderDonationType {
  ROUND = "ROUND",
  UNIQUE = "UNIQUE",
}

export enum OrderSortField {
  CREATED_AT = "CREATED_AT",
  ID = "ID",
  TOTAL_AMOUNT = "TOTAL_AMOUNT",
}

export enum OrderStatusCode {
  ACCEPTED = "ACCEPTED",
  CANCELED = "CANCELED",
  COMPLETE = "COMPLETE",
  GPOINT_SHIPPED = "GPOINT_SHIPPED",
  GROBY_SHIPPED = "GROBY_SHIPPED",
  INVOICED = "INVOICED",
  MARKED_TO_CANCEL = "MARKED_TO_CANCEL",
  MPL_SHIPPED = "MPL_SHIPPED",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PAYMENT_RECEIVED = "PAYMENT_RECEIVED",
  PAYMENT_REFUSED = "PAYMENT_REFUSED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
}

export enum Permission {
  LOGIN_AS_USER = "LOGIN_AS_USER",
  MANAGE_ADMINS = "MANAGE_ADMINS",
  MANAGE_BANNERS = "MANAGE_BANNERS",
  MANAGE_CMS = "MANAGE_CMS",
  MANAGE_COUPONS = "MANAGE_COUPONS",
  MANAGE_DASHBOARD = "MANAGE_DASHBOARD",
  MANAGE_DONATIONS = "MANAGE_DONATIONS",
  MANAGE_ORDERS = "MANAGE_ORDERS",
  MANAGE_PAYMENTS = "MANAGE_PAYMENTS",
  MANAGE_PRODUCTS = "MANAGE_PRODUCTS",
  MANAGE_PRODUCT_ATTRIBUTES = "MANAGE_PRODUCT_ATTRIBUTES",
  MANAGE_PRODUCT_CATEGORIES = "MANAGE_PRODUCT_CATEGORIES",
  MANAGE_PRODUCT_LIST_ADS = "MANAGE_PRODUCT_LIST_ADS",
  MANAGE_PRODUCT_VOTES = "MANAGE_PRODUCT_VOTES",
  MANAGE_SHIPPING = "MANAGE_SHIPPING",
  MANAGE_TIMETABLES = "MANAGE_TIMETABLES",
  MANAGE_URL_ALIASES = "MANAGE_URL_ALIASES",
  MANAGE_USERS = "MANAGE_USERS",
  MANAGE_USER_DISCOUNTS = "MANAGE_USER_DISCOUNTS",
}

export enum ProductAlternativeQuantityName {
  db = "db",
  karton = "karton",
}

export enum ProductAttributeType {
  MULTIPLE = "MULTIPLE",
  SIMPLE = "SIMPLE",
}

export enum ProductDefaultQuantityName {
  db = "db",
  kg = "kg",
}

export enum ProductListAdType {
  BANNER = "BANNER",
  PRODUCT = "PRODUCT",
}

export enum ProductStatus {
  AVAILABLE = "AVAILABLE",
  OUT_OF_STOCK = "OUT_OF_STOCK",
  PERMANENTLY_ENDED = "PERMANENTLY_ENDED",
  SEASONAL = "SEASONAL",
  UNAVAILABLE = "UNAVAILABLE",
}

export enum PromotionPlace {
  PROMO_1 = "PROMO_1",
  PROMO_2 = "PROMO_2",
  PROMO_3 = "PROMO_3",
}

export enum TimetableTimeSlotStatusType {
  ACTIVE = "ACTIVE",
  FULL = "FULL",
  INACTIVE = "INACTIVE",
}

export enum TimetableTimeSlotsOrderField {
  ID = "ID",
  RANG_DATE = "RANG_DATE",
}

export enum UserSortField {
  EMAIL = "EMAIL",
  EXT_ID = "EXT_ID",
  ID = "ID",
  NAME = "NAME",
}

export enum getProductBy {
  ID = "ID",
  URL = "URL",
}

export interface AdminBannerFilters {
  id?: string | null;
  name?: string | null;
  is_active?: boolean | null;
  banner_place_id?: string | null;
  banner_place_type_id?: BannerPlaceType | null;
}

export interface AdminBannerOrder {
  field: AdminBannerOrderField;
  direction: OrderDirection;
}

export interface AdminCmsContentFilters {
  id?: string | null;
  title?: string | null;
  is_active?: boolean | null;
  url_key?: string | null;
}

export interface AdminCmsContentOrder {
  field: AdminCmsContentField;
  direction: OrderDirection;
}

export interface AdminCouponOrder {
  field: AdminCouponOrderField;
  direction: OrderDirection;
}

export interface AdminCouponsFilter {
  name?: string | null;
  is_active?: boolean | null;
  type?: CouponType[] | null;
  applied_to?: CouponAppliedTo[] | null;
}

export interface AdminDonationsFilter {
  name?: string | null;
  is_active?: boolean | null;
}

export interface AdminDonationsOrder {
  field: AdminDonationOrderField;
  direction: OrderDirection;
}

export interface AdminProductFilters {
  name?: string | null;
  category?: string[] | null;
  is_special?: boolean | null;
  is_new?: boolean | null;
  productStatus?: ProductStatus[] | null;
  numericRange?: AdminProductNumericFieldRangeFilter[] | null;
  is_mpl?: boolean | null;
  ext_id?: number | null;
}

export interface AdminProductImageInput {
  file_name: string;
  base64_image: string;
}

export interface AdminProductListAdFilter {
  name?: string | null;
  is_active?: boolean | null;
  type?: ProductListAdType[] | null;
}

export interface AdminProductListAdOrder {
  field: AdminProductListAdField;
  direction: OrderDirection;
}

export interface AdminProductNumericFieldRangeFilter {
  field: AdminNumericFields;
  from: number;
  to: number;
}

export interface AdminProductOrder {
  field: AdminProductOrderField;
  direction: OrderDirection;
}

export interface CouponCodeAttributes {
  count: number;
  length?: number | null;
  type?: CouponCodeType | null;
  prefix?: string | null;
  suffix?: string | null;
  pattern?: string | null;
}

export interface CouponPriceRangeInput {
  from: number;
  discount: number;
}

export interface DonationActiveDates {
  active_from: string;
  active_to: string;
}

export interface OrderFilters {
  id?: string | null;
  user_id?: string | null;
  user_ext_id?: string | null;
  timetable_time_slot_id?: string | null;
  contact_name?: string | null;
  status_id?: string | null;
  shipping_method_id?: string | null;
  payment_method_id?: string | null;
  create_at_from?: any | null;
  create_at_to?: any | null;
  is_admin_checked?: boolean | null;
}

export interface OrderSort {
  field: OrderSortField;
  direction: OrderDirection;
}

export interface ProductListAdUrlInput {
  url: string;
  position: number;
}

export interface ShippingMethodPriceRangeInput {
  from: number;
  price: number;
}

export interface TimetableTimeSlotsFilters {
  id?: string | null;
  range_date?: any | null;
  status?: TimetableTimeSlotStatusType | null;
  timetable_sector_id?: string | null;
}

export interface TimetableTimeSlotsOrder {
  field: TimetableTimeSlotsOrderField;
  direction: OrderDirection;
}

export interface UserFilters {
  id?: string | null;
  ext_id?: string | null;
  name?: string | null;
  email?: string | null;
}

export interface UserSort {
  field: UserSortField;
  direction: OrderDirection;
}

//==============================================================
// END Enums and Input Objects
//==============================================================



// WEBPACK FOOTER //
// ./src/api/graphql/types.ts